import React, { Component, Fragment } from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import Modal from "@material-ui/core/Modal";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import { Col, CardBody, Button, Table, Row } from "reactstrap";
import {
  KeyboardDatePicker,
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import "moment/locale/es";
import { withStyles } from "@material-ui/core/styles";
import FormCompanions from "./FormCompanions";
import history from "../../../../history";
import AdmisionSocket from "../../SocketAdmision/AdmisionSocket";
import Checkbox from "@material-ui/core/Checkbox";
import FormRepresent from "./FormRepresent";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import SaveIcon from "@material-ui/icons/Save";
import ModalMessage from "../../../../shared/components/Modal";
import FormEspecialReq from "./FormEspecialReq";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import BlockIcon from "@material-ui/icons/Block";
import ReceiptsAdmisions from "../../SearchAdmissions/components/ReceiptsAdmissions";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import ModalAdditionalAppointment from "../../../Calendar/ModalAdditionalAppointment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import DigitalSignature from "../../../DigitalSignature/DigitalSignature";
import { calculateAgeParse } from "../../../Utils/Patient";
import SearchModalCIE10 from "../../../SearchModals/CIE10/SearchModalCIE10";
import { actions } from "react-table";
import FormDisability from "./FormDisability";
import { Dialog } from "@material-ui/core";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  getContentAnchorEl: null,
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 650,
    },
  },
};
const styles = (theme) => ({
  date: {
    margin: 10,
    width: 215,
  },
});

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#84ffe7",
      main: "#49e0b5",
      dark: "#00ad85",
      contrastText: "#fff",
      height: "10px",
    },
  },
});

const defaultMaterialTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#3EA3FC",
      contrastText: "#fff",
    },
  },
});
const MedicalCheckbox = withStyles({
  root: {
    "&$checked": {
      color: "#4ce1b6",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const CHIP_MAX_WIDTH = 800;
const CHIP_ICON_WIDTH = 30;

const EllipsisText = (props) => {
  const { children } = props;

  return (
    <div
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: CHIP_MAX_WIDTH - CHIP_ICON_WIDTH,
      }}
    >
      {children}
    </div>
  );
};

const profile = sessionStorage.getItem("perfil");

var user = sessionStorage.getItem("usuario");
user = JSON.parse(user);

class FormAddAdmission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typeOfDocument: "",
      documentNumber: "",
      names: "",
      firstLastName: "",
      secondLastName: "",
      gender: "",
      bloodType: "",
      date: new Date(),
      birthday: null,
      age: "",
      civilStatus: "",
      race: "",
      races: [],
      poblacionVulnerable: null,
      poblaciones: [],
      workspace: "",
      workspaces: "",
      ethnicity: "",
      ethnicities: [],
      countries: [],
      tiposUsuario: [],
      causasMotivoAtencion: [],
      tiposConsulta: [],
      viasIngresoSalud: [],
      country: "00038",
      countryOrigin: "00038",
      department: "",
      city: "",
      departments: [],
      cities: [],
      address: "",
      telephone1: "",
      telephone2: "",
      cellphone: "",
      email: "",
      regime: "",
      ocupation: "",
      occupations: [],
      regimes: [],
      professional: "",
      professionals: [],
      companion: "No",
      numberCompaions: 1,
      costumer: "", //Id del tercero
      costumer_data: null, // Todos los datos del tercero
      activity: {},
      activities: [],
      plan: "",
      plans: [],
      serter: [],
      id_patient: null,
      id_history: null,
      exist: false,
      openShowMore: true,
      disability: null, 
      disabilities: [],
      selectedDisability: [],
      edit_disability: false,
      errors: {
        typeOfDocument: "",
        documentNumber: "",
        names: "",
        firstLastName: "",
        secondLastName: "",
        gender: "",
        birthday: "",
        country: "",
        countryOrigin: "",
        department: "",
        city: "",
        address: "",
        telephone: "",
        cellphone: "",
        email: "",
        civilStatus: "",
        race: "",
        ethnicity: "",
        poblacionVulnerable: "",
        bloodType: "",
        professional: "",
        workspace: "",
        regime: "",
        costumer: "",
        plan: "",
        activity: "",
        medico_remitente: "",
        companions: [
          {
            number: "",
            name: "",
            firstTelephone: "",
            secondTelephone: "",
            typeCompanion: "",
            relationship: "",
          },
        ],
        represent: [
          {
            number: "",
            name: "",
            firstTelephone: "",
            secondTelephone: "",
            typeCompanion: "",
            relationship: "",
          },
        ],
        rangeLevelRegime: "",
        ocupation: "",
        disability:""
      },
      error: false,
      disableData: false,
      companions: [
        {
          number: "",
          name: "",
          firstTelephone: "",
          secondTelephone: "",
          relationship: "",
          typeCompanion: [],
        },
      ],
      represent: [
        {
          number: "",
          name: "",
          firstTelephone: "",
          secondTelephone: "",
          typeCompanion: "",
          relationship: "",
        },
      ],
      disabled: false,
      disabledInput: false,
      load: false,
      pertenece_estudio: false,
      estudios_clinicos: [],
      estudio_clinico: null,
      visitas: [],
      visita: null,
      authorization: "",
      affiliation: "",
      weight: "",
      height: "",
      imc: "",
      zone: "U",
      typeConsult: "10",
      externalCause: "13",
      viaIngreso: "2",
      activitiesAppointment: [],
      medico_remitente: "",
      id_tecnologo: "",
      openAlert: false,
      modalAlert: { title: "", color: "", message: "" },
      listTipos: JSON.parse(sessionStorage.getItem("centroTipos")),
      typecares: [],
      typecare: "",
      onUpdate: false,
      requerimientos_especiales: {},
      disableEspReqForm: false,
      caidas: {
        caida_previa: "",
        medicamentos: "",
        def_sensoriales: "",
        estado_mental: "",
        deambulacion: "",
        valor: 0,
        riesgo: "",
        fecha_hora: moment(new Date()).format("DD-MM-YYYY HH:mm:ss"),
      },
      openShowRisk: false,
      openShowReqEsp: false,
      observacion: "",
      editRegimenAndServices: false,
      editLegalRepresent: false,
      editCompanion: false,
      creationProcess: null,
      successStatus: null,
      rangeLevelRegime: "",
      id_admision: "",
      edit_fallingRisk: false,
      disableFormFalling: false,
      colorFallingRisk: "#6F6964",
      edit_reqEspeciales: false,
      admisionFather: null,
      confirmedAdditionalAppointments: [],
      menopause: null,
      menstruationPatientDate: null,
      planningMethod: null,
      pregnancyTest: null,
      womanInformationEdit: false,
      nameInitialPhase: null,
      openModalAdditionalAppointment: false,
      signaturePatient: null,
      modalSignaturePad: false,
      typeOfUser: "",
      editInfoAdmission: false,
      editInfoPatient: false,
      validationCode: null,
      showSpecialReq: false,
      showFeminineInfo: false,
      showFallingRisks: false,
      observationFieldEdit: false,
      theresAppointment: false,
      idAdmissionToCert: 0,
      listReferringDoctors: [],
      referringDoctors: [],
      docRemAdd: "",
      workplaces: [],
      workplaceSelected: null,
      userPermits: [],
      dietaPaciente: "",
      dietasPacientes: [],
      numHabitacion: null,
      descripcionHabitacion: null,
      fechaIngreso: new Date(),
      editInfoAislamiento: false,
      id_habitacion: null,
      fechaEgreso: new Date(),
      openModalDiagnostico: false,
      diagnosticAislamiento: null,
      isViewPage: false,
      openAlertNoti: false,
      modalAlertNoti: { title: "", color: "", message: "" },
      estado_facturacion: null,
      openDisability: true,
      openAlertDisability: false,
    };
  }

  loadDisability = async () =>{
    await fetch (process.env.REACT_APP_PUBLIC_URL + "discapacidades/listar-discapacidades",{
      method: "GET",
      headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + sessionStorage.getItem("token"),
    },
    }).then((response) =>{
      return response.json()
    }).then((data) =>{
      this.setState({disabilities: data}) 
    }).catch((error) => {
      console.error("Error:", error)
    })
  }


  loadPatientDiets = async () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "dietas-pacientes/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
          this.setState({ dietasPacientes: data });
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadWorkplaces = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "sedes/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error(response.json());
        }
      })
      .then((data) => {
        this.setState({
          workplaces: data.contenido,
          workplaceSelected: !!data.contenido.length
            ? data.contenido[0].id_sede
            : null,
        });
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({ workplaces: [] });
      });
  };

  loadOccupations = async () => {
    await fetch (process.env.REACT_APP_PUBLIC_URL + 'ocupaciones/listar',{
      method:"GET",
      headers:{
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      }
    }).then((response) =>{
      return response.json()
    }).then((data)=>{      
      this.setState({occupations: data})
    }).catch((error)=>{
      console.error("Error", error)
    })

  }

  handlerWorkplace = (id) => {
    this.setState({ workplaceSelected: id });
  };

  organizeFallingRisksFromProps = () => {
    if (
      this.props.dataPatient.caidas !== null &&
      this.props.dataPatient.caidas !== undefined
    ) {
      this.setState({ caidas: this.props.dataPatient.caidas });
    }
  };

  dataCaidaSet = (caida) => {
    this.setState({ caidas: caida });
  };

  setCaidaCaPr = (radioCaidaPreviaAnswer) => {
    this.setState(
      {
        caidas: {
          ...this.state.caidas,
          caida_previa: radioCaidaPreviaAnswer,
        },
      },
      () => {
        this.getRiesgoFallingRisk();
      }
    );
  };

  setCaida2CaPr = (radioCaidaPreviaAnswer) => {
    this.setState(
      {
        caidas: {
          ...this.state.caidas,
          medicamentos: radioCaidaPreviaAnswer,
        },
      },
      () => {
        this.getRiesgoFallingRisk();
      }
    );
  };

  setCaida3CaPr = (radioCaidaPreviaAnswer) => {
    this.setState(
      {
        caidas: {
          ...this.state.caidas,
          def_sensoriales: radioCaidaPreviaAnswer,
        },
      },
      () => {
        this.getRiesgoFallingRisk();
      }
    );
  };

  setCaida4CaPr = (radioCaidaPreviaAnswer) => {
    this.setState(
      {
        caidas: {
          ...this.state.caidas,
          estado_mental: radioCaidaPreviaAnswer,
        },
      },
      () => {
        this.getRiesgoFallingRisk();
      }
    );
  };

  setCaida5CaPr = (radioCaidaPreviaAnswer) => {
    this.setState(
      {
        caidas: {
          ...this.state.caidas,
          deambulacion: radioCaidaPreviaAnswer,
        },
      },
      () => {
        this.getRiesgoFallingRisk();
      }
    );
  };

  getRiesgoFallingRisk = () => {
    let valor = 0;
    let riesgo;

    if (this.state.caidas.caida_previa === "Sí") valor = valor + 1;

    if (this.state.caidas.medicamentos === "Sí") valor = valor + 1;

    if (
      this.state.caidas.def_sensoriales === "Alteraciones Visuales, Auditivas"
    )
      valor = valor + 1;

    if (this.state.caidas.estado_mental === "Confuso") valor = valor + 1;

    if (this.state.caidas.deambulacion === "No") valor = valor + 1;

    if (valor >= 3) {
      riesgo = "Alto";
    } else if (valor == 2) {
      riesgo = "Medio";
    } else {
      riesgo = "Bajo";
    }

    this.setState({
      caidas: {
        caida_previa: this.state.caidas.caida_previa,
        medicamentos: this.state.caidas.medicamentos,
        def_sensoriales: this.state.caidas.def_sensoriales,
        estado_mental: this.state.caidas.estado_mental,
        deambulacion: this.state.caidas.deambulacion,
        valor: valor,
        riesgo: riesgo,
        fecha_hora: this.state.caidas.fecha_hora,
      },
    });

    return riesgo;
  };

  organizeReqEspFromProps = () => {
    if (
      this.props.dataPatient.requerimientos_especiales !== null &&
      this.props.dataPatient.requerimientos_especiales !== undefined
    ) {
      this.setState({
        requerimientos_especiales:
          this.props.dataPatient.requerimientos_especiales,
      });
    }
  };

  setReqHospitalizado = (chkHospitalizad) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        hospitalizado: chkHospitalizad,
      },
    });
  };

  setReqSillas = (chkSillas) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        sillas: chkSillas,
      },
    });
  };

  setReqMuletas = (chkMuletas) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        muletas: chkMuletas,
      },
    });
  };

  setReqSintomas = (chkSintoma) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        sintomas_respiratorios: chkSintoma,
      },
    });
  };

  setReqOxigeno = (chkOxigeno) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        oxigeno: chkOxigeno,
      },
    });
  };

  setReqCamilla = (chkCamilla) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        camilla: chkCamilla,
      },
    });
  };

  setReqAmbulancia = (chkAmbulancia) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        ambulancia: chkAmbulancia,
      },
    });
  };

  setReqNinguno = (chkNinguno) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        ninguno: chkNinguno,
      },
    });
    if (chkNinguno == false) {
      this.setState({
        disableEspReqForm: false,
        requerimientos_especiales: {
          hospitalizado: false,
          sillas: false,
          muletas: false,
          sintomas_respiratorios: false,
          oxigeno: false,
          camilla: false,
          ambulancia: false,
          ninguno: chkNinguno,
          otro: false,
          otroReq: "",
        },
      });
    } else {
      this.setState({
        disableEspReqForm: true,
        requerimientos_especiales: {
          ...this.state.requerimientos_especiales,
          hospitalizado: false,
          sillas: false,
          muletas: false,
          sintomas_respiratorios: false,
          oxigeno: false,
          camilla: false,
          ambulancia: false,
          ninguno: chkNinguno,
          otro: false,
          otroReq: "",
        },
      });
    }
  };

  setReqOtro = (chkOtro) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        otro: chkOtro,
      },
    });
  };

  setReqOtroReq = (chkOtroReq) => {
    this.setState({
      requerimientos_especiales: {
        ...this.state.requerimientos_especiales,
        otroReq: chkOtroReq,
      },
    });
  };

  handlerDisableEspReqForm = (action) => {
    this.setState({ disableEspReqForm: action });
  };

  handlerMedicoRemitente = (medico_remitente) => {
    this.setState({ medico_remitente: medico_remitente.toUpperCase() });
  };

  handlerDocumentNumber = (number) => {
    this.setState({ documentNumber: number }, () => {
      if (!this.state.onUpdate && this.props.dataPatient.dataPatient === null) {
        this.loadDataPatient(number);
      }
    });
  };

  handlerTypeOfDocument = (type) => {
    this.setState({ typeOfDocument: type });
  };

  handlerNames = (name) => {
    this.setState({ names: name.toUpperCase() });
  };

  handlerFirstLastName = (name) => {
    this.setState({ firstLastName: name.toUpperCase() });
  };

  handlerSecondLastName = (name) => {
    this.setState({ secondLastName: name.toUpperCase() || "" });
  };

  handlerGender = (gender) => {
    this.setState({ gender: gender });
  };

  handlerBloodType = (bloodType) => {
    this.setState({ bloodType: bloodType });
  };

  handlerDate = (date) => {
    this.setState({ date: date });
  };

  handleDateEntry = (dateEntry) => {
    this.setState({ fechaIngreso: dateEntry });
  };

  handleDateEgress = (dateEgress) => {
    this.setState({ fechaEgreso: dateEgress });
  };

  handleRoomNumber = (numRoom) => {
    this.setState({ numHabitacion: numRoom });
  };

  handleRoomDescription = (descripcion) => {
    this.setState({ descripcionHabitacion: descripcion });
  };

  handlerBirthDate = (birthday) => {
    this.setState({ birthday: birthday });
  };

  handlerCivilStatus = (status) => {
    this.setState({ civilStatus: status });
  };

  handlerRace = (raceForm) => {
    this.setState({ race: raceForm });
  };

  handlePoblacionVulnerable = (poblacion) => {
    this.setState({ poblacionVulnerable: poblacion });
  };

  handlerEthnicity = (ethnicityForm) => {
    this.setState({ ethnicity: ethnicityForm });
  };

  handlerCountry = (country) => {
    this.setState({ country: country });
  };

  handlerCountryOrigin = (countryOrigin) => {
    this.setState({ countryOrigin: countryOrigin });
  };

  handlerDepartment = (department) => {
    this.setState({ department: department, city: {} }, () => {
      this.loadCities(department).then((cities) => {
        this.setState({ cities: cities });
      });
    });
  };

  handlerCity = (city) => {
    this.setState({ city: city });
  };

  handlerAddress = (address) => {
    this.setState({ address: address });
  };

  handlerTelephone1 = (telephone) => {
    this.setState({ telephone1: telephone });
  };

  handlerTelephone2 = (telephone) => {
    this.setState({ telephone2: telephone });
  };

  handlerCellphone = (cellphone) => {
    this.setState({ cellphone: cellphone });
  };

  handlerEmail = (email) => {
    this.setState({ email: email.toUpperCase() });
  };

  handlerRegime = (regime) => {
    this.setState({ regime: regime });
  };

  handlerProfessional = (professional) => {
    this.setState({ professional: professional });
  };

  handlerWorkspace = (workspace) => {
    this.setState({ workspace: workspace });
  };

  handlerCompanion = (companion) => {
    this.setState({ companion: companion });
  };

  handlerCostumer = (costumer) => {
    this.setState({ visita: null, activitiesAppointment: [] });
    this.setState({ costumer: costumer.id_tercero, costumer_data: costumer });
    //this.getThirdAdmision(costumer.id_tercero);
    //this.loadPlansFromContract(parseInt(costumer.id_contrato));

    switch (parseInt(costumer.tipo)) {
      case 1: //Tercero Normal
        this.setState({
          pertenece_estudio: false,
          regime: costumer.id_regimen,
        });
        this.loadPlansFromContract(costumer.id_contrato);
        break;
      case 2: //Patrocinador
        this.setState({ pertenece_estudio: true, regime: null });
        this.loadClinicalStudio(costumer.id_tercero);
        break;
      default:
        this.setState({
          pertenece_estudio: false,
          regime: costumer.id_regimen,
        });
        this.loadPlansFromContract(costumer.id_contrato);
    }
  };

  handlerAuthorization = (authorization) => {
    this.setState({ authorization: authorization });
  };

  handlerTypeOfUser = (typeOfUser) => {
    this.setState({ typeOfUser: typeOfUser });
  };

  handleDietsPacient = (event) => {
    this.setState({ dietaPaciente: event.target.value });
  };

  handlerAffiliation = (affiliation) => {
    this.setState({ affiliation: affiliation });
  };

  handlerActivity = (activity, activityOriginal) => {
    if (
      this.state.confirmedAdditionalAppointments.some(
        (confAdd) =>
          confAdd.detalle_servicio.id_servicio == activityOriginal.id_servicio
      ) != true
    ) {
      if (this.state.activitiesAppointment.length > 0) {
        if (
          this.state.activitiesAppointment.some(
            (ac) => ac.requiere_multicitas == true
          )
        ) {
          if (
            this.state.activitiesAppointment.some(
              (ac) => ac.id_servicio == activityOriginal.id_servicio
            )
          ) {
            this.setState({
              activitiesAppointment: activity.filter(
                (appointment) =>
                  appointment.id_servicio != activityOriginal.id_servicio
              ),
            });
          } else {
            this.setState({
              openAlert: true,
              modalAlert: {
                title: "Servicio Multicitas",
                message:
                  "Ha agregado un servicio de Multicitas, para agendar otro servicio debe hacerlo en citas adicionales",
                color: "danger",
              },
            });
          }
        } else {
          if (activityOriginal.requiere_multicitas != true) {
            this.setState({ activitiesAppointment: activity });
          } else {
            this.setState({
              openAlert: true,
              modalAlert: {
                title: "Servicio Multicitas",
                message:
                  "No puede agregar un servicio multicitas si ya hay otros servicios asignados, para realizar esta acción debe agendar los servicios elegidos para otro dia en citas adicionales",
                color: "danger",
              },
            });
          }
        }
      } else {
        this.setState({ activitiesAppointment: activity });
      }
    } else {
      this.setState({
        activitiesAppointment: activity.filter(
          (appointment) =>
            appointment.id_servicio != activityOriginal.id_servicio
        ),
      });
    }
  };

  handlerPlan = (plan) => {
    this.setState({ plan: plan, activitiesAppointment: [] });
  };

  handlerChangeVisits = async (value) => {
    this.setState({ visita: value });
  };

  handlerObservationAdd = (value) => {
    this.setState({ observacion: value });
  };

  handlerChangeClinicalStudio = async (value) => {
    this.setState({ estudio_clinico: value });

    if (value != null) {
      this.loadVisitas(value.id_factibilidad);
    } else {
      this.setState({ visita: null });
      this.setState({ visitas: [] });
    }
  };

  handlerZone = (zone) => {
    this.setState({ zone: zone });
  };

  handleDisability = (disability) =>{    
    if(this.state.selectedDisability.length > 0 && disability === "No"){
      this.setState({ openAlertDisability: true });
      this.setState({selectedDisability: [] });
    }
    this.setState({disability: disability})
  }

  handleSelectDisability = (disability) =>{
    this.setState({ selectedDisability: disability });
  }

  handleEditDisability = (edit) => {
    this.setState({ edit_disability: edit });
  } 

  handlerRangeLevelRegime = (range) => {
    this.setState({ rangeLevelRegime: range });
  };

  handlerValidationCode = (value) => {
    this.setState({ validationCode: value });
  };

  getImc = () => {
    var gImc = 0;
    if (this.state.weight === "" || this.state.height === "") {
      return "";
    } else {
      var w = parseInt(this.state.weight);
      var h = parseFloat(this.state.height) / 100;
      gImc = (w / (h * h)).toFixed(2);
      this.setState({ imc: gImc });
    }
  };

  validatePermissionsActionsAdmission = () => {
    var user = JSON.parse(sessionStorage.getItem("usuario"));
    if (user != null) {
      if (user.perfil != undefined) {
        var perfil = user.perfil.modulos;
        var id_perfil = user.perfil.id_perfil;
        this.setState({ userPermits: perfil });
      } else {
        var perfil = [];
      }
    } else {
      setUserPermits([]);
    }
  };

  componentDidMount = () => {
    this.validateShowInfoClinic();
    this.organizeReqEspFromProps();
    this.organizeFallingRisksFromProps();
    this.loadWorkplaces();
    this.validatePermissionsActionsAdmission();
    this.loadPatientDiets();
    this.loadOccupations();
    this.loadDisability()

    if (this.props.dataPatient.dataPatient !== null) {
      this.setState({
        disabledInput: true,
        editInfoPatient: true,
        isViewPage: true,
      });
    }

    if (
      this.state.id_admision !== null &&
      this.state.id_admision !== undefined &&
      this.state.id_admision !== ""
    ) {
      this.setState({ disableFormFalling: true });
    }

    if (this.state.listTipos.includes("4")) {
      this.loadRefferingProfessionals();
    }

    this.loadCountries();
    this.loadTipoUsuarioSalud();
    this.loadTipoConsulta();
    this.loadCausaMotivoAtencion();
    this.loadViasIngresoSalud();
    this.setState({ load: true }, () => {
      Promise.all([
        this.loadDataProfessional(),
        this.loadThirdPlusContract(),
        this.LoadRaces(),
        this.loadPoblacionVulnerable(),
        this.LoadEthnicities(),
        this.getNameRegime(),
        this.fetchDataWorkspace(),
        this.loadDepartment(),
        this.fetchTypeCares(),
      ])
        .then((result) => {
          this.setState(
            {
              professionals: result[0],
              serter: result[1],
              races: result[2],
              poblaciones: result[3],
              ethnicities: result[4],
              regimes: result[5],
              workspaces: result[6],
              departments: result[7],
              typecares: result[8],
            },
            () => {
              //data.filter((depart) => { return depart.id === sessionStorage.getItem('id_dpto') })[0].depcod
              this.setState(
                {
                  department: this.state.departments.filter((depart) => {
                    return (
                      depart.id === parseInt(sessionStorage.getItem("id_dpto"))
                    );
                  })[0].depcod,
                },
                () => {
                  this.loadCities(this.state.department).then((cities) => {
                    this.setState({ cities: cities }, () => {
                      this.setState({
                        city: this.state.cities.filter((city) => {
                          return (
                            city.id ===
                            parseInt(sessionStorage.getItem("id_ciudad"))
                          );
                        })[0].ciucod,
                      });
                    });
                  });
                }
              );
            }
          );
        })
        .then(() => {
          if (this.props.dataPatient.hasOwnProperty("id_admision")) {
            this.loadAdmission();
            this.loadDigitalSignatureAdmission(
              this.props.dataPatient.id_admision
            );
          } else if (
            this.props.dataPatient.hasOwnProperty("id_cita") &&
            this.props.dataPatient.hasOwnProperty("id_historia")
          ) {
            this.loadDataPatient(this.props.dataPatient.document_number);
            this.setState({
              documentNumber: this.props.dataPatient.document_number,
              requerimientos_especiales:
                this.props.dataPatient.requerimientos_especiales,
              id_history: this.props.dataPatient.id_historia,
            });
            this.loadVerifyAdmisionForAppointment(
              this.props.dataPatient.id_cita
            );
            this.loadConsultRoom(this.props.dataPatient.id_cita);
          }

          if (!!this.props.dataPatient?.dataPatient?.aislamiento) {
            this.loadConsultarAislamiento(
              this.props.dataPatient.dataPatient.id_admision
            );
          }

          this.setState({ load: false });
        })
        .catch((error) => console.error(`Error in promises ${error}`));
    });
  };

  loadRefferingProfessionals = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "profesional-remitente/listar",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((dataResponse) => {
        if (dataResponse != null && dataResponse != undefined) {
          this.setState({ listReferringDoctors: dataResponse });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  
  createRefferingProfessional = async (nombre) => {
    if (!nombre) return;
    let data = { nombre };
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "profesional-remitente/create",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((dataResponse) => {
        if (dataResponse.data != null && dataResponse.data != undefined) {
          this.setState({ docRemAdd: "" }, () => {
            this.loadRefferingProfessionals();
            this.handlerPushReffereingDoc(dataResponse.data, "select-option");
            this.handlerAddRefferingDocToString(
              dataResponse.data,
              "select-option"
            );
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  handlerAddRefferingDocToString = (docObject, reason) => {
    let newRefferingDocs = "";
    let currentStringRefferingDocs = this.state.medico_remitente;
    if (reason === "select-option") {
      if (!!currentStringRefferingDocs) {
        newRefferingDocs =
          currentStringRefferingDocs + " | " + docObject.nombre;
      } else {
        newRefferingDocs = docObject.nombre;
      }
    } else {
      let splittedDocs = currentStringRefferingDocs
        .split("|")
        .map((name) => name.toString().trim());
      if (splittedDocs.includes(docObject.nombre)) {
        let newArray = splittedDocs.filter((name) => name !== docObject.nombre);
        newRefferingDocs = newArray.reduce(
          (acc, cur, idx) =>
            newArray.length === idx + 1 ? acc + cur : acc + cur + " | ",
          ""
        );
      }
    }
    this.setState({ medico_remitente: newRefferingDocs });
  };

  handlerPushReffereingDoc = (docObject, reason) => {
    let currentRefferingDoctors = this.state.referringDoctors;
    let newRefferingDocs = [];
    if (reason === "select-option") {
      newRefferingDocs = [...currentRefferingDoctors, docObject];
    } else {
      newRefferingDocs = currentRefferingDoctors.filter(
        (doc) =>
          doc.id_profesional_remitente !== docObject.id_profesional_remitente
      );
    }
    this.setState({ referringDoctors: newRefferingDocs });
  };

  loadDigitalSignatureAdmission = async (id_admision) => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "admision/consultar-firma-digital?id_admision=" +
        id_admision,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((dataResponse) => {
        if (
          dataResponse.firma_digital != null &&
          dataResponse.firma_digital != undefined
        ) {
          this.setState({
            signaturePatient:
              process.env.REACT_APP_PUBLIC_URL +
              dataResponse.firma_digital.url_firma +
              sessionStorage.getItem("token"),
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  loadVerifyAdmisionForAppointment = async (id_cita) => {
    if (
      this.props.dataPatient.id_cita != null &&
      this.props.dataPatient.id_cita != undefined
    ) {
      await fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "admision/consultar-por-cita?id_cita=" +
          id_cita,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          //Si ya existe una admision relacionada con la Cita, llena los datos restantes y desactiva los campos
          if (response.admision !== null) {
            this.setState({
              disabled: true,
              authorization: response.admision.codigo_autorizacion,
              affiliation: response.admision.num_afiliacion,
              externalCause: response.admision.causa_externa,
              viaIngreso: response.admision.via_ingreso,
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  loadConsultarAislamiento = async (id_admision) => {
    const dataAis = {
      id_admision: id_admision,
    };
    fetch(process.env.REACT_APP_PUBLIC_URL + "admision/consultar-aislamiento", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataAis),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          numHabitacion: data.numero,
          descripcionHabitacion: data.descripcion,
          dietaPaciente: data.id_dieta_paciente,
          id_habitacion: data.id_habitacion,
          fechaIngreso: data.fecha_ingreso,
          diagnosticAislamiento: {
            id: data.diagnostico_principal_egreso,
            nombre: data.cie10_nombre,
            codigo: data.cie10_codigo,
          },
        });

        if (data.fecha_egreso) {
          this.setState({ fechaEgreso: data.fecha_egreso });
        }
      });
  };

  loadConsultRoom = async (id_cita) => {
    const data = {
      id_cita: id_cita,
    };
    fetch(process.env.REACT_APP_PUBLIC_URL + "cita/consultar-habitacion", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.existe) {
          this.setState({
            numHabitacion: data.contenido.numero,
            descripcionHabitacion: data.contenido.descripcion,
            dietaPaciente: data.contenido.id_dieta_paciente,
            id_habitacion: data.contenido.id_habitacion,
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadAdmission = () => {
    var data = {
      id_admision: parseInt(this.props.dataPatient.id_admision),
      id_historia: 0,
      num_documento: "0",
      fecha: "0",
    };

    fetch(process.env.REACT_APP_PUBLIC_URL + "admision/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.existe) {
          var companions = [];
          if (data.contenido[0].acompanante?.hasOwnProperty("acompañante")) {
            companions = data.contenido[0].acompanante?.acompañante?.map(
              (acompañante) => {
                return {
                  name: acompañante.nombre,
                  number: acompañante.num_documento,
                  relationship: acompañante.parentesco,
                  typeCompanion: [acompañante.rol],
                  firstTelephone: acompañante.tel1,
                  secondTelephone: acompañante.tel2,
                };
              }
            ); 
          }
          if (
            this.props.dataPatient.caidas !== null &&
            this.props.dataPatient.caidas !== undefined
          ) {
            //this.organizeFallingRisksFromProps();
            try {
              var caidas = {
                caida_previa:
                  this.props.dataPatient.caidas != null
                    ? this.props.dataPatient.caidas.caida_previa
                    : "",
                medicamentos:
                  this.props.dataPatient.caidas != null
                    ? this.props.dataPatient.caidas.medicamentos
                    : "",
                def_sensoriales:
                  this.props.dataPatient.caidas != null
                    ? this.props.dataPatient.caidas.def_sensoriales
                    : "",
                estado_mental:
                  this.props.dataPatient.caidas != null
                    ? this.props.dataPatient.caidas.def_sensoriales
                    : "",
                deambulacion:
                  this.props.dataPatient.caidas != null
                    ? this.props.dataPatient.caidas.deambulacion
                    : "",
                valor:
                  this.props.dataPatient.caidas != null
                    ? this.props.dataPatient.caidas.valor
                    : 0,
                riesgo:
                  this.props.dataPatient.caidas != null
                    ? this.props.dataPatient.caidas.riesgo
                    : "",
                fecha_hora:
                  this.props.dataPatient.caidas != null
                    ? moment(this.props.dataPatient.caidas.fecha).format(
                        "DD-MM-YYYY HH:mm:ss"
                      )
                    : null,
              };

              this.setState({ caidas: caidas });
            } catch (error) {
              console.error("Error de Caida", error);
            }
          } else {
            try {
              var caidas = {
                caida_previa:
                  data.contenido[0].caidas_cita != null
                    ? data.contenido[0].caidas_cita.caida_previa
                    : "",
                medicamentos:
                  data.contenido[0].caidas_cita != null
                    ? data.contenido[0].caidas_cita.medicamentos
                    : "",
                def_sensoriales:
                  data.contenido[0].caidas_cita != null
                    ? data.contenido[0].caidas_cita.def_sensoriales
                    : "",
                estado_mental:
                  data.contenido[0].caidas_cita != null
                    ? data.contenido[0].caidas_cita.def_sensoriales
                    : "",
                deambulacion:
                  data.contenido[0].caidas_cita != null
                    ? data.contenido[0].caidas_cita.deambulacion
                    : "",
                valor:
                  data.contenido[0].caidas_cita != null
                    ? data.contenido[0].caidas_cita.valor
                    : 0,
                riesgo:
                  data.contenido[0].caidas_cita != null
                    ? data.contenido[0].caidas_cita.riesgo
                    : "",
                fecha_hora:
                  data.contenido[0].caidas_cita != null
                    ? moment(data.contenido[0].caidas_cita.fecha).format(
                        "DD-MM-YYYY HH:mm:ss"
                      )
                    : null,
              };

              this.setState({ caidas: caidas });
            } catch (error) {
              console.error("Error de Caida", error);
            }
          }
          if (
            this.props.dataPatient.requerimientos_especiales !== null &&
            this.props.dataPatient.requerimientos_especiales !== undefined
          ) {
            //this.organizeReqEspFromProps();
            try {
              let reqEspData =
                this.props.dataPatient.requerimientos_especiales != null
                  ? this.props.dataPatient.requerimientos_especiales
                  : null;
              var requerimientos_especiales = {
                hospitalizado:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.hospitalizado
                    : null,
                sillas:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.sillas
                    : null,
                muletas:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.muletas
                    : null,
                sintomas_respiratorios:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales
                        .sintomas_respiratorios
                    : null,
                oxigeno:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.oxigeno
                    : null,
                camilla:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.camilla
                    : null,
                ambulancia:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.ambulancia
                    : null,
                ninguno:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.ninguno
                    : null,
                otro:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.otro
                    : null,
                otroReq:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.otroReq
                    : null,
              };
              this.setState(
                { requerimientos_especiales: requerimientos_especiales }
              );
            } catch (error) {
              console.error("Error al cargar req. Esp.", error);
            }
          } else {
            try {
              let reqEspData =
                data.contenido[0].requerimientos_especiales != null
                  ? data.contenido[0].requerimientos_especiales
                  : null;
              var requerimientos_especiales = {
                hospitalizado:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.hospitalizado
                    : null,
                sillas:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.sillas
                    : null,
                muletas:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.muletas
                    : null,
                sintomas_respiratorios:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales
                        .sintomas_respiratorios
                    : null,
                oxigeno:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.oxigeno
                    : null,
                camilla:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.camilla
                    : null,
                ambulancia:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.ambulancia
                    : null,
                ninguno:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.ninguno
                    : null,
                otro:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.otro
                    : null,
                otroReq:
                  reqEspData.requerimientos_especiales != null
                    ? reqEspData.requerimientos_especiales.otroReq
                    : null,
              };
              this.setState(
                { requerimientos_especiales: requerimientos_especiales }
              );
            } catch (error) {
              console.error("Error al cargar req. Esp.", error);
            }
          }

          let represent = [];
          if (
            data.contenido[0].representante_legal?.hasOwnProperty(
              "representante_legal"
            )
          ) {
            represent =
              data.contenido[0].representante_legal.representante_legal.map(
                (repre) => {
                  return {
                    name: repre.nombre_completo,
                    number: repre.num_documento,
                    relationship: repre.parentesco,
                    firstTelephone: repre.telefono1,
                    secondTelephone: repre.telefono2,
                  };
                }
              );
          }
        
          this.setState(
            {
              typeOfDocument: data.contenido[0].tip_documento,
              documentNumber: data.contenido[0].num_documento,
              id_patient: data.contenido[0].id_paciente,
              id_history: data.contenido[0].id_historia,
              names: data.contenido[0].nombres,
              firstLastName: data.contenido[0].apellido1,
              secondLastName: data.contenido[0].apellido2
                ? data.contenido[0].apellido2
                : "",
              gender: data.contenido[0].sexo,
              address: data.contenido[0].direccion.direccion,
              country: data.contenido[0].direccion.id_pais,
              countryOrigin: data.contenido[0].direccion.id_pais_origen,
              email: data.contenido[0].correo,
              cellphone: data.contenido[0].celular,
              telephone1: data.contenido[0].telefono1,
              telephone2: data.contenido[0].telefono2,
              birthday: data.contenido[0].fec_nacimiento,
              civilStatus: data.contenido[0].e_civil,
              ocupacion: data.contenido[0].ocupacion,
              bloodType: data.contenido[0].tipo_sangre,
              regime: data.contenido[0].id_regimen,
              costumer: data.contenido[0].id_tercero,
              plan: data.contenido[0].id_plan,
              activity: data.contenido[0].id_servicio,
              professional: data.contenido[0].id_profesional,
              race: data.contenido[0].id_raza,
              ethnicity:data.contenido[0].id_etnia,
              workspace: data.contenido[0].id_espacio,
              date: data.contenido[0].fecha,
              disability: data.contenido[0].discapacidad?.discapacidad ?? null,
              selectedDisability: data.contenido[0].discapacidad?.discapacidades ?? [],
              zone:
                data.contenido[0].zona != undefined &&
                data.contenido[0].zona != null
                  ? data.contenido[0].zona
                  : null,
              companion: companions.length > 0 ? "Si" : "No",
              represent: represent,
              exist: true,
              openShowMore: false,
              load: false,
              rangeLevelRegime: data.contenido[0].rango_regimen,
              authorization: data.contenido[0].codigo_autorizacion,
              validationCode: data.contenido[0].codigo_validacion,
              typeOfUser: data.contenido[0].tipo_usuario_salud,
              affiliation: data.contenido[0].num_afiliacion,
              externalCause: data.contenido[0].causa_externa,
              viaIngreso: data.contenido[0].via_ingreso,
              medico_remitente: data.contenido[0].remitente,
              referringDoctors: !!data.contenido[0].remitente_medicos
                ? data.contenido[0].remitente_medicos.hasOwnProperty("medicos")
                  ? data.contenido[0].remitente_medicos.medicos
                  : []
                : [],
              estado_facturacion: data.contenido[0].estado_facturacion,
              disabled: true,
            },
            () => {
              /* if (companions.length < 0) {
                companions = [
                  {
                    number: "",
                    name: "",
                    firstTelephone: "",
                    secondTelephone: "",
                    relationship: "",
                    typeCompanion: [],
                  },
                ];
              } */
              if (!!companions.length) {
                let errors = this.state.errors;
                for (let i=1; i<companions.length; i++) {
                  errors.companions.push({
                    number: "",
                    name: "",
                    firstTelephone: "",
                    secondTelephone: "",
                    typeCompanion: "",
                    relationship: "",
                  });
                }

                this.setState({ errors: errors });
              }

              this.handlerDepartment(
                data.contenido[0].direccion.id_departamento
              );
              this.setState({
                companions: companions,
                city: data.contenido[0].direccion.id_ciudad,
              });

              this.loadDataCita();
              /*Promise.all([this.loadPlans(data.contenido[0].id_tercero), this.loadActivities(data.contenido[0].id_tercero, data.contenido[0].id_plan, data.contenido[0].id_servicio)]).then((results) => {
                            this.setState({ plans: results[0], activities: results[1], activity: data.contenido[0].id_servicio, load: false })
                        });*/
            }
          );
          this.loadDataCostumer(data.contenido[0].id_tercero);
        } else {
          this.setState({
            id_patient: "",
            firstName: "",
            firstLastName: "",
            secondLastName: "",
            gender: "",
            address: "",
            email: "",
            cellphone: "",
            telephone1: "",
            telephone2: "",
            birthday: new Date(),
            exist: false,
            openShowMore: true,
            load: false,
          });
        }
      })
      .catch((error) => {
        console.error("Error", error);
      });
  };

  loadDataCostumer = (id_cliente) => {
    for (let i = 0; i < this.state.serter.length; i++) {
      if (this.state.serter[i].id_tercero == id_cliente) {
        this.setState({ costumer_data: this.state.serter[i] });
        break;
      }
    }
  };

  fetchTypeCares = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "atencion/listar", {
        method: "GET",
        headers: {
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((typecares) => {
          resolve(typecares);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  loadDataProfessional = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "profesional/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          //this.setState({ professionals: data });
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadClientAndActivity = () => {
    return new Promise((resolve, reject) => {
      //let url = "serter/listar";
      let url = "tercero/listar-terceros-indicadores";

      fetch(process.env.REACT_APP_PUBLIC_URL + url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadDataPatient = (documentNumber) => {
    var data = { num_documento: documentNumber };
    fetch(process.env.REACT_APP_PUBLIC_URL + "paciente/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {        
        if (data.existe) {
          this.setState(
            {
              typeOfDocument: data.contenido[0].tip_documento,
              //documentNumber: data.contenido[0].num_documento,
              id_patient: data.contenido[0].id_paciente,
              names: data.contenido[0].nombres,
              firstLastName: data.contenido[0].apellido1,
              secondLastName: data.contenido[0].apellido2
                ? data.contenido[0].apellido2
                : "",
              gender: data.contenido[0].sexo,
              address: data.contenido[0].direccion.direccion,
              country: data.contenido[0].direccion.id_pais,
              countryOrigin: data.contenido[0].direccion.id_pais_origen,
              email: data.contenido[0].correo,
              regime: data.contenido[0].id_regimen,
              cellphone: data.contenido[0].celular,
              telephone1: data.contenido[0].telefono1,
              telephone2: data.contenido[0].telefono2,
              civilStatus: data.contenido[0].e_civil,
              race: data.contenido[0].id_raza,
              ethnicity: data.contenido[0].id_etnia,
              bloodType: data.contenido[0].tipo_sangre,
              birthday: data.contenido[0].fec_nacimiento,
              zone: data.contenido[0].zona,
              ocupation: data.contenido[0].ocupacion,
              exist: true,
              editInfoPatient: true,
              disabled: false,
              onUpdate: false,
              history: data.contenido[0]?.id_historia,
              //openShowMore: false
            },
            () => {
              this.handlerDepartment(
                data.contenido[0].direccion.id_departamento
              );
              this.setState({ city: data.contenido[0].direccion.id_ciudad });
              this.calculateAge(data.contenido[0].fec_nacimiento);

              if (this.props.dataPatient.dataPatient !== null)
                this.loadDataCita();
            }
          );
        } else {
          this.setState(
            {
              id_patient: "",
              typeOfDocument: "",
              names: "",
              firstName: "",
              firstLastName: "",
              secondLastName: "",
              gender: "",
              address: "",
              email: "",
              cellphone: "",
              telephone1: "",
              telephone2: "",
              birthday: new Date(),
              race: "",
              ethnicity: "",
              bloodType: "",
              civilStatus: "",
              regime: "",
              zone: "U",
              exist: false,
              openShowMore: true,
              onUpdate: false,
              editInfoPatient: false,
            },
            () => {
              this.loadDepartment().then((departments) => {
                this.setState({ departments: departments }, () => {
                  this.setState(
                    {
                      department: this.state.departments.filter((depart) => {
                        return (
                          depart.id ===
                          parseInt(sessionStorage.getItem("id_dpto"))
                        );
                      })[0].depcod,
                    },
                    () => {
                      this.loadCities(this.state.department).then((cities) => {
                        this.setState({ cities: cities }, () => {
                          this.setState({
                            city: this.state.cities.filter((city) => {
                              return (
                                city.id ===
                                parseInt(sessionStorage.getItem("id_ciudad"))
                              );
                            })[0].ciucod,
                          });
                        });
                      });
                    }
                  );
                });
              });
            }
          );
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadDataCita = () => {
    var data = {
      id_cita:
        typeof this.props.dataPatient.id_cita !== "undefined"
          ? this.props.dataPatient.id_cita
          : this.props.dataPatient.dataPatient.id_cita,
    };
    //id_agenda: this.props.dataEvent.id_agenda
    fetch(process.env.REACT_APP_PUBLIC_URL + "agenda/consultarpaciente", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.existe) {
          this.calculateAge(data.contenido.f_nac);
          if (data.contenido.pertenece_estudio == false) {
            console.log("No entiendo porque se recarga");
            Promise.all([
              this.loadPlansFromContract(data.contenido.id_contrato),
              this.loadActivities(
                data.contenido.idCliente,
                data.contenido.idPlan,
                data.contenido.id_profesional,
                data.contenido.idActividad
              ),
            ]).then((results) => {
              this.setState(
                {
                  activities: results[1],
                  activity: data.contenido.idActividad,
                },
                () => {
                  let selectedServices = this.filterGetSelectedServices(data);
                  if (
                    this.props.dataPatient.requerimientos_especiales !== null &&
                    this.props.dataPatient.requerimientos_especiales !==
                      undefined
                  ) {
                    this.setState({
                      requerimientos_especiales:
                        this.props.dataPatient.requerimientos_especiales,
                    });
                  } else {
                    this.setState({
                      requerimientos_especiales:
                        data.contenido.requerimientos_especiales,
                    });
                  }
                  if (
                    this.props.dataPatient.caidas !== null &&
                    this.props.dataPatient.caidas !== undefined
                  ) {
                    this.setState({ caidas: this.props.dataPatient.caidas });
                  } else {
                    this.setState({ caidas: data.contenido.caidas });
                  }

                  let serterData = this.state.serter.find(
                    (ser) => ser.id_contrato == data.contenido.id_contrato
                  );

                  this.setState(
                    {
                      costumer_data:
                        serterData != null && serterData != undefined
                          ? serterData
                          : this.state.costumer_data,
                      id_patient: data.contenido.id_paciente,
                      name: data.contenido.nombres,
                      document_number: data.contenido.numDoc,
                      last_name:
                        data.contenido.ape1 + " " + data.contenido.ape2,
                      cellphone: data.contenido.celular,
                      telephone1: data.contenido.telefono1,
                      telephone2: data.contenido.telefono2,
                      email: data.contenido.correo,

                      birthday:
                        data.contenido.f_nac != null
                          ? new Date(data.contenido.f_nac)
                          : null,
                      history: data.contenido.id_historia,
                      costumer: data.contenido.idCliente,
                      plan: data.contenido.idPlan,
                      //activity: data.contenido.servicios.servicios.id_servicio,
                      professional: data.contenido.id_profesional,
                      date:
                        typeof this.props.dataPatient.cita !== "undefined"
                          ? this.props.dataPatient.cita.fecha
                          : this.state.date,
                      workspace:
                        typeof this.props.dataPatient.workspace !== "undefined"
                          ? this.props.dataPatient.workspace ===
                            "Toma de Muestras 1"
                            ? 4
                            : this.props.dataPatient.workspace ===
                              "Consultorio 2"
                            ? 2
                            : this.props.dataPatient.workspace ===
                              "Consultorio 1"
                            ? 1
                            : data.contenido.id_espacio
                          : this.props.dataPatient.workspace,
                      load: false,
                      pertenece_estudio: data.contenido.pertenece_estudio,
                      height: data.contenido.talla,
                      weight: data.contenido.peso,
                      activitiesAppointment: selectedServices,
                      typeConsult: data.contenido.tipo_consulta,
                      regime: data.contenido.regimen,
                      zone:
                        data.contenido.zona != null ? data.contenido.zona : "",
                      ocupation: data.contenido.ocupacion ,
                      race: data.contenido.raza,
                      bloodType: data.contenido.tipo_sangre,
                      ethnicity: data.contenido.etnia,
                      poblacionVulnerable: !!data.contenido.id_poblacion_vulnerable ? data.contenido.id_poblacion_vulnerable : "Ninguna",
                      openShowMore: true,
                      imc: data.contenido.imc,
                      observacion: data.contenido.observacion,
                      id_admision:
                        data.contenido.admision !== null &&
                        data.contenido.admision !== undefined
                          ? data.contenido.admision.id_admision
                          : "",
                      disableFormFalling:
                        data.contenido.admision !== null &&
                        data.contenido.admision !== undefined
                          ? true
                          : false,
                      workplaceSelected: data.contenido.id_sede,
                    },
                    () => {
                      if (
                        data.contenido.detallesAdmisionPadre !== null &&
                        data.contenido.detallesAdmisionPadre !== undefined
                      ) {
                        this.setState({
                          authorization:
                            data.contenido.detallesAdmisionPadre !== null
                              ? data.contenido.detallesAdmisionPadre
                                  .codigo_autorizacion
                              : null,
                          medico_remitente:
                            data.contenido.detallesAdmisionPadre !== null
                              ? data.contenido.detallesAdmisionPadre.remitente
                              : null,
                          rangeLevelRegime:
                            data.contenido.detallesAdmisionPadre !== null
                              ? data.contenido.detallesAdmisionPadre
                                  .rango_regimen
                              : null,
                          admisionFather:
                            data.contenido.detallesAdmisionPadre !== null
                              ? data.contenido.detallesAdmisionPadre
                              : null,
                        });

                        try {
                          if (
                            data.contenido.detallesAdmisionPadre.acompanante?.hasOwnProperty(
                              "acompañante"
                            )
                          ) {
                            let companions = [];
                            companions =
                              data.contenido.detallesAdmisionPadre.acompanante.acompañante.map(
                                (acompañante) => {
                                  return {
                                    name: acompañante.nombre,
                                    number: acompañante.num_documento,
                                    relationship: acompañante.parentesco,
                                    typeCompanion: [acompañante.rol],
                                    firstTelephone: acompañante.tel1,
                                    secondTelephone: acompañante.tel2,
                                  };
                                }
                              );
                            this.setState(
                              {
                                companion: companions.length > 0 ? "Si" : "No",
                              },
                              () => {
                                if (companions.length < 0) {
                                  companions = [
                                    {
                                      number: "",
                                      name: "",
                                      firstTelephone: "",
                                      secondTelephone: "",
                                      relationship: "",
                                      typeCompanion: [],
                                    },
                                  ];
                                }
                              }
                            );
                          }

                          let represent = [];
                          if (
                            data.contenido.detallesAdmisionPadre.representante_legal.hasOwnProperty(
                              "representante_legal"
                            )
                          ) {
                            represent =
                              data.contenido.detallesAdmisionPadre.representante_legal.representante_legal.map(
                                (repre) => {
                                  return {
                                    name: repre.nombre_completo,
                                    number: repre.num_documento,
                                    relationship: repre.parentesco,
                                    firstTelephone: repre.telefono1,
                                    secondTelephone: repre.telefono2,
                                  };
                                }
                              );

                            this.setState({ represent: represent });
                          }
                        } catch (e) {
                          console.error(e);
                        }
                      }
                    }
                  );
                }
              );
            });
          } else {
            Promise.all([
              this.loadClinicalStudio(data.contenido.idCliente),
              this.loadVisitas(
                data.contenido.estudio_detalle.detalle.estudio_clinico
                  .id_factibilidad
              ),
            ]).then((results) => {
              this.setState(
                { estudios_clinicos: results[0], visitas: results[1] },
                () => {
                  let estudio = null;
                  let visita = null;
                  //Estudio Clinico
                  for (let i = 0; i < results[0].length; i++) {
                    if (
                      results[0][i].id_estudio ==
                      data.contenido.estudio_detalle.detalle.estudio_clinico
                        .id_estudio
                    ) {
                      estudio = results[0][i];
                      break;
                    }
                  }
                  //Visita
                  for (let i = 0; i < results[1].length; i++) {
                    if (
                      results[1][i].id_visita ==
                      data.contenido.estudio_detalle.detalle.visita.id_visita
                    ) {
                      visita = results[1][i];
                      break;
                    }
                  }

                  this.setState({
                    id_patient: data.contenido.id_paciente,
                    name: data.contenido.nombres,
                    document_number: data.contenido.numDoc,
                    last_name: data.contenido.ape1 + " " + data.contenido.ape2,
                    cellphone: data.contenido.celular,
                    telephone1: data.contenido.telefono1,
                    telephone2: data.contenido.telefono2,
                    email: data.contenido.correo,
                    birthday:
                      data.contenido.f_nac != null
                        ? new Date(data.contenido.f_nac)
                        : null,
                    history: data.contenido.id_historia,
                    costumer: data.contenido.idCliente,
                    professional:
                      typeof this.props.dataPatient.cita !== "undefined"
                        ? this.props.dataPatient.cita.id_profesional
                        : "",
                    date:
                      typeof this.props.dataPatient.cita !== "undefined"
                        ? this.props.dataPatient.cita.fecha
                        : this.state.date,
                    workspace: this.props.dataPatient.workspace,
                    estudio_clinico: estudio,
                    visita: visita,
                    load: false,
                    pertenece_estudio: data.contenido.pertenece_estudio,
                    height: data.contenido.talla,
                    weight: data.contenido.peso,
                    imc: data.contenido.imc,
                  });
                }
              );
            });
          }
          this.loadDataCostumer(data.contenido.idCliente);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  filterGetSelectedServices = (data) => {
    let selectedServices = [];
    for (let i = 0; i < data.contenido.servicios.servicios.length; i++) {
      let serData = this.state.activities.find(
        (dat) =>
          parseInt(dat.id_servicio) ==
          parseInt(data.contenido.servicios.servicios[i].id_servicio)
      );
      if (serData != null && serData != undefined) {
        selectedServices.push(serData);
      }
    }
    return selectedServices;
  };

  loadPlans = (tercero) => {
    return new Promise((resolve, reject) => {
      var data = { id: tercero };
      fetch(process.env.REACT_APP_PUBLIC_URL + "plan/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.existe) {
            //this.setState({plans: data.contenido, activities: [], activity: null });
            resolve(data.contenido);
          } else {
            resolve([]);
            //this.setState({plans:[], plan: null, activities: [], activity: null});
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadActivities = (tercero, plan, profesional) => {
    return new Promise((resolve, reject) => {
      let citaNueva = false;
      if (this.props.dataPatient.dataPatient === null) {
        citaNueva = true;
      }

      var data = { id_tercero: tercero, id_plan: plan, cita_nueva: citaNueva };
      let url = `serter/verificar-profesional?id_tercero=${tercero}&id_plan=${plan}&id_profesional=${profesional}&cita_nueva=${citaNueva}`;
      fetch(process.env.REACT_APP_PUBLIC_URL + url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
          this.setState({ activities: data, activity: actividad });
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  //#region Estudios Clinicos
  loadClinicalStudio = async (id_tercero) => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL + "estudiosc/consultar-por-tercero",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify({ id_tercero: id_tercero }),
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({ estudios_clinicos: data });
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve([]);
        });
    });
  };

  loadVisitas = (id_factibilidad) => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "visitas/consultar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify({ id_factibilidad: id_factibilidad }),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({ visitas: data.contenido });
          resolve(data.contenido);
        })
        .catch((error) => {
          console.error("Error:", error);
          this.setState({ visitas: [] });
          resolve([]);
        });
    });
  };

  LoadEthnicities = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "etnia/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  LoadRaces = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "raza/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadPoblacionVulnerable = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "poblacion-vulnerable/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  loadRegimes = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "regimen/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  getNameRegime = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "regimen-contratos/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error(response.json());
          }
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
          console.error(error);
        });
    });
  };

  fetchDataWorkspace = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "espacio/listar", {
        method: "GET",
        headers: {
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((workspaces) => {
          resolve(workspaces);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  loadCountries = async () => {
    //

    await fetch(process.env.REACT_APP_PUBLIC_URL + "paises/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ countries: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadDepartment = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "departamentos/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  loadCities = (depcod) => {
    var data = { id_dpto: depcod };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "ciudades/listar", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  calculateAge = (birthday) => {
    let edadTotal = calculateAgeParse(birthday);
    this.setState({ age: edadTotal });
  };

  //Se cargan los terceros + regimen
  loadThirdPlusContract = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "agenda/listar-terceros", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  //Carga los planes desde el contrato
  loadPlansFromContract = async (id) => {
    let data = { id_contrato: id };

    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "plan/consultar_x_contrato",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.existe) {
          this.setState({ plans: data.contenido, pertenece_estudio: false });
        } else {
          this.setState({ plans: [], pertenece_estudio: false });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadTipoUsuarioSalud = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "admision/consultar-tipos-usuario",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ tiposUsuario: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadCausaMotivoAtencion = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "admision/listar-causa-motivo-atencion",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ causasMotivoAtencion: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadViasIngresoSalud = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "admision/listar-via-ingreso-salud",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ viasIngresoSalud: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  loadTipoConsulta = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "admision/listar-tipo-consulta",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ tiposConsulta: data });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  validateAislamiento = () => {
    var errors = this.state.errors;
    var error = false;

    if (!this.state.diagnosticAislamiento?.codigo) {
      errors.diagnosticAislamiento = "Seleccione un diagnostico";
      error = true;
    } else {
      errors.diagnosticAislamiento = "";
    }

    this.setState({ errors: errors });
    return error;
  };

  validateForm = () => {
    var errors = this.state.errors;
    var error = false;

    if (this.state.typeOfDocument === "") {
      errors.typeOfDocument = "Seleccione un tipo de documento";
      error = true;
    } else {
      errors.typeOfDocument = "";
    }

    if (this.state.documentNumber === "") {
      errors.documentNumber = "Ingrese un número de documento";
      error = true;
    } else {
      errors.documentNumber = "";
    }

    if (this.state.names === "") {
      errors.names = "Ingrese al menos un nombre";
      error = true;
    } else {
      errors.names = "";
    }

    if (this.state.medico_remitente === "") {
      errors.medico_remitente = "Ingrese el nombre del Medico remitente";
      error = true;
    } else {
      errors.medico_remitente = "";
    }

    if (this.state.firstLastName === "") {
      errors.firstLastName = "Ingrese apellido";
      error = true;
    } else {
      errors.firstLastName = "";
    }

    if (this.state.gender === "") {
      errors.gender = "Seleccione un genero";
      error = true;
    } else {
      errors.gender = "";
    }

    if (this.state.birthday === null) {
      errors.birthday = "Seleccione una fecha";
      error = true;
    } else if (!moment(this.state.birthday).isValid()) {
      errors.birthday = "Seleccione una fecha valida";
      error = true;
    } else {
      errors.birthday = "";
    }

    // if (this.state.birthday === null) {
    //   errors.birthday = "Seleccione una fecha";
    //   error = true;
    // } else {
    //   errors.birthday = "";
    // }

    if (this.state.country === "") {
      errors.country = "Seleccione un país";
      error = true;
    } else {
      errors.country = "";
    }

    if (
      this.state.countryOrigin === "" ||
      this.state.countryOrigin === undefined
    ) {
      errors.countryOrigin = "Seleccione un país de origen";
      error = true;
    } else {
      errors.countryOrigin = "";
    }

    if (this.state.department === "") {
      errors.department = "Seleccione un departamento";
      error = true;
    } else {
      errors.department = "";
    }

    if (this.state.city === "") {
      errors.city = "Seleccione una ciudad";
      error = true;
    } else {
      errors.city = "";
    }

    if (this.state.address === "") {
      errors.address = "Ingrese una dirección";
      error = true;
    } else if (!this.state.address.match(/^[a-zA-Z0-9\s]+$/)) {
      errors.address = "Ingrese una dirección sin caracteres especiales";
      error = true;
    } else {
      errors.address = "";
    }

    if (this.state.cellphone === "") {
      errors.cellphone = "Ingrese una celular";
      error = true;
    } else {
      errors.cellphone = "";
    }

    if (!this.state.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) {
      errors.email = "Ingrese un e-mail valido";
      error = true;
    } else {
      errors.email = "";
    }

    if (this.state.civilStatus === "") {
      errors.civilStatus = "Seleccione un estado civil";
      error = true;
    } else {
        errors.civilStatus = "";
    }
   
    if ( this.state.race === null ) {
        errors.race = "Seleccione un raza";
        error = true;
    } else {
        errors.race = "";
    }

    if (this.state.ethnicity === null) {
        errors.ethnicity = "Seleccione etnia";
        error = true;
    } else {
        errors.ethnicity = "";
    }

    if (this.state.bloodType === ""|| this.state.bloodType === null) {
      errors.bloodType = "Seleccione un tipo de sangre";
      error = true;
    } else {
        errors.bloodType = "";
    }

    if (this.state.ocupation <= 0) {
      errors.ocupation = "Seleccione una ocupación";
      error = true;
    } else {
      errors.ocupation = "";
    }

    if (this.state.professional === "") {
      errors.professional = "Seleccione un profesional";
      error = true;
    } else {
      errors.professional = "";
    }

    if (this.state.workspace === "") {
      errors.workspace = "Seleccione un espacio de trabajo";
      error = true;
    } else {
      errors.workspace = "";
    }

    if (this.state.regime === "") {
      errors.regime = "Seleccione un regimen";
      error = true;
    } else {
      errors.regime = "";
    }

    if (
      this.state.regime !== null &&
      this.state.regime !== "" &&
      (this.state.regime === 2 || this.state.regime === 3)
    ) {
      if (this.state.rangeLevelRegime === "") {
        //errors.rangeLevelRegime = "Seleccione un rango o nivel";
        //error = true;
        errors.rangeLevelRegime = "";
      } else {
        errors.rangeLevelRegime = "";
      }
    }

    if (this.state.typeOfUser === "") {
      errors.typeOfUser = "Seleccione un tipo de usuario";
      error = true;
    } else {
      errors.typeOfUser = "";
    }

    if (!!this.state.numHabitacion) {
      if (
        this.state.dietaPaciente === "" ||
        this.state.dietaPaciente === null
      ) {
        errors.dietaPaciente = "Seleccione una dieta para el paciente";
        error = true;
      } else {
        errors.dietaPaciente = "";
      }
    }

    if (typeof this.state.costumer === null || this.state.costumer == "") {
      errors.costumer = "Seleccione un Cliente";
      error = true;
    } else {
      errors.costumer = "";
    }

    if (!this.state.pertenece_estudio) {
      if (this.state.plan === "") {
        errors.plan = "Seleccione un plan";
        error = true;
      } else {
        errors.plan = "";
      }

      if (this.state.activitiesAppointment.length < 1) {
        errors.activity = "Seleccione al menos un servicio";
        error = true;
      } else {
        errors.activity = "";
      }
    }

    if (this.state.pertenece_estudio) {
      if (this.state.estudio_clinico === null) {
        errors.estudio_clinico = "Seleccione un estudio";
        error = true;
      } else {
        errors.estudio_clinico = "";
      }

      if (this.state.visita === null) {
        errors.visita = "Selecione una Visita";
        error = true;
      } else {
        errors.visita = "";
      }
    }

    if (this.state.listTipos.includes("3")) {
      if (this.state.weight === "") {
        errors.weight = "Ingrese el peso";
        error = true;
      } else {
        errors.weight = "";
      }

      if (this.state.height === "") {
        errors.height = "Ingrese la talla";
        error = true;
      } else if (this.state.height < 20) {
        errors.height = "Ingrese una talla mayor a 20cm";
        error = true;
      } else {
        errors.height = "";
      }
    }

    /*
       if (typeof this.state.activity === null || this.state.activity == undefined) {
           errors.activity = "Seleccione un servicio";
           error = true;
       } else {
           errors.activity = "";
       }
       */

    /*if (this.state.zone === undefined || this.state.zone === null) {
            errors.zone = "Ingrese una Zona";
            error = true;
        } else {
            errors.zone = "";
        }*/

    /* if (this.state.authorization === "") {
             errors.authorization = "Escriba el numero de autorizacion";
             error = true;
         } else {
             errors.authorization = "";
         }
 
         if (this.state.affiliation === "") {
             errors.affiliation = "Escriba el numero de afiliacion";
             error = true;
         } else {
             errors.affiliation = "";
         }*/

    /*  errors.represent = new Array(this.state.represent.length);
         this.state.represent.map((repre, index) => {
             errors.represent[index] = {};
             if (repre.number === "") {
                 errors.represent[index].number = "Ingrese un numero de documento";
                 error = true;
             } else {
                 errors.represent[index].number = "";
             }
             if (repre.name === "") {
                 errors.represent[index].name = "Ingrese un nombre";
                 error = true;
             } else {
                 errors.represent[index].name = "";
             }
             if (repre.firstTelephone === "") {
                 errors.represent[index].firstTelephone = "Ingrese un teléfono";
                 error = true;
             } else {
                 errors.represent[index].firstTelephone = "";
             }
             if (repre.relationship === "") {
                 errors.represent[index].relationship = "Ingrese un parentesco";
                 error = true;
             } else {
                 errors.represent[index].relationship = "";
             }
         }) */

    if (this.state.companion === "Si") {
      errors.companions = new Array(this.state.companions.length);
      this.state.companions.map((companion, index) => {
        errors.companions[index] = {};
        if (companion.number === "") {
          errors.companions[index].number = "Ingrese un numero de documento";
          error = true;
        } else {
          errors.companions[index].number = "";
        }
        if (companion.name === "") {
          errors.companions[index].name = "Ingrese un nombre";
          error = true;
        } else {
          errors.companions[index].name = "";
        }
        if (companion.firstTelephone === "") {
          errors.companions[index].firstTelephone = "Ingrese un telefono";
          error = true;
        } else {
          errors.companions[index].firstTelephone = "";
        }
        if (companion.relationship === "") {
          errors.companions[index].relationship = "Seleccione una relación";
          error = true;
        } else {
          errors.companions[index].relationship = "";
        }
      });
    }

    if((this.state.selectedDisability.length === 0  && this.state.disability === "Si") || this.state.disability === null ) {
      this.setState({
        openAlert: true,
        modalAlert: {
          title: "Discapacidad no se ha diligenciado",
          message: "Debe seleccionar una discapacidad si el paciente la tiene",
          color:"danger",
        }
      })
      error = true;
    }

    if (this.state.listTipos.includes("3") || this.state.showFallingRisks) {
      if (this.state.caidas.riesgo === "") {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "El riesgo de caída no se ha diligenciado",
            message: "Para continuar con el agendamiento debe de llenarlo",
            color: "danger",
          },
        });
        error = true;
      }
    }

    if (this.state.listTipos.includes("3") || this.state.showSpecialReq) {
      if (
        this.state.requerimientos_especiales == null ||
        JSON.stringify(this.state.requerimientos_especiales) === "{}" ||
        this.state.requerimientos_especiales == undefined
      ) {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Los requerimientos Especiales no se han diligenciado",
            message: "Para continuar con el agendamiento debe de llenarlo",
            color: "danger",
          },
        });
        error = true;
      }
    }

    //Esteban Londoño Ospina 29/11/2021
    //Valida que el Doctor si tenga una agenda
    if (this.state.professional !== "") {
      let id_agenda_activa = this.state.professionals.filter((professional) => {
        return professional.id_profesional === this.state.professional;
      })[0].id_agenda_activa;
      if (id_agenda_activa == null) {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Agenda Invalida",
            message:
              "Este profesional no tiene una agenda activa, debe elegir otro profesional o asignarle una agenda",
            color: "danger",
          },
        });
        return true;
      }
    }

    if (error == false) {
      let validateQueryProcedure = this.validatedQuerysAndProcedures();
      if (!validateQueryProcedure) {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Consulta y Procedimiento unificados",
            message:
              "No puede asignar una cita con una consulta y un procedimiento al mismo tiempo",
            color: "danger",
          },
        });
        error = true;
      }
    }

    if (this.state.editRegimenAndServices == true) {
      error = true;
      this.setState({
        openAlert: true,
        modalAlert: {
          title: "Error",
          message:
            "Esta editando el Regimen, Plan y Servicios, por favor diligencielos y guarde los Cambios para continuar",
          color: "danger",
        },
      });
    }
    this.setState({ errors: errors });
    return error;
  };

  //Realiza la validacion de que no se mezclen consultas con procedimientos antes de guardar para evitar Glosas de Factura con SURA!
  validatedQuerysAndProcedures = () => {
    let activities = this.state.activitiesAppointment;
    let querysActivities = activities.some((act) => act.id_rips_concepto == 1);
    let proceduresActivites = activities.some(
      (act) => act.id_rips_concepto != 1
    );
    if (querysActivities == true && proceduresActivites == true) {
      return false;
    } else {
      return true;
    }
  };

  sendDataFormAdmission = async () => {
    if (!this.validateForm()) {
      if (
        this.props.dataPatient.hasOwnProperty("id_cita") &&
        this.props.dataPatient.hasOwnProperty("id_historia")
      ) {
        var data = {
          //fecha: moment(this.state.date).format('YYYY-MM-DD'),
          //hora: moment(this.state.date).format('hh:mm a'),
          fecha: moment(new Date()).format("YYYY-MM-DD"),
          hora: moment(new Date()).format("hh:mm a"),
          id_cita: this.props.dataPatient.id_cita,
          id_historia: this.props.dataPatient.id_historia,
          id_agenda: this.props.dataPatient.id_agenda,
          id_cita_agendada: this.props.dataPatient.id_bloque,
          id_tercero: this.props.dataPatient.cita.id_plan,
          id_sede: 2,
          causa_externa: this.state.externalCause,
          remitente: this.state.medico_remitente,
          observacion: this.state.observacion,
          rango_regimen: this.state.rangeLevelRegime,
          tipo_usuario_salud: this.state.typeOfUser,
          via_ingreso: this.state.viaIngreso,
        };

        if (this.state.companion === "Si") {
          data.acompañantes = this.state.companions.map((companion) => {
            return {
              num_documento: companion.number,
              rol: companion.typeCompanion[0],
              nombre: companion.name,
              tel1: companion.firstTelephone,
              tel2: companion.secondTelephone,
              parentesco: companion.relationship,
            };
          });
        }

        if(this.state.disability === "Si") {
          data.discapacidad = {
            discapacidad: this.state.disability,
            discapacidades: this.state.selectedDisability,
          }
        }else{
          data.discapacidad = {
            discapacidad: this.state.disability,
            discapacidades: [],
          }  
        }         

        data.representante_legal = this.state.represent.map((repre) => {
          return {
            num_documento: repre.number,
            nombre_completo: repre.name,
            telefono1: repre.firstTelephone,
            telefono2: repre.secondTelephone,
            parentesco: repre.relationship,
          };
        });

        data.pertenece_estudio = this.state.pertenece_estudio;

        //Esteban Londoño Ospina 25/09/2021
        //Si pertenece a un estudio clinico se guarda la informacion correspondiente
        let estudio_detalle = null;
        if (this.state.pertenece_estudio == true) {
          estudio_detalle = {
            estudio_clinico: this.state.estudio_clinico,
            visita: this.state.visita,
          };
          data.estudio_detalle = estudio_detalle;
        } else {
          data.estudio_detalle = null;
        }

        data.codigo_autorizacion = this.state.authorization;
        data.num_afiliacion = this.state.affiliation;
        data.requerimientos_especiales = this.state.requerimientos_especiales;
        data.caidas = this.state.caidas;
        data.firma_paciente = this.state.signaturePatient;
        data.codigo_validacion = this.state.validationCode;
        data.remitente_medicos = this.state.referringDoctors;
        data.numHabitacion = this.state.numHabitacion;
        data.descripcionHabitacion = this.state.descripcionHabitacion;
        data.dietaPaciente = this.state.dietaPaciente;
        data.fechaIngreso = moment(this.state.fechaIngreso).format(
          "YYYY-MM-DD hh:mm a"
        );

        let usuario = JSON.parse(sessionStorage.getItem("usuario"));
        data.id_usuario = usuario.id_usuario;

        await fetch(process.env.REACT_APP_PUBLIC_URL + "admision/create", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(data),   
        })
          .then((response) => {
            if (response.status != 500 && response.status != 403) {
              return response
                .json()
                .then((data) => {
                  if (this.state.costumer_data.recibos_cero_admitir) {
                    this.createReceipt(data.admision);
                  }
                  this.setState({
                    successStatus: 1,
                    disabled: true,
                    openAlert: true,
                    modalAlert: {
                      title: "Admisión",
                      message: data.mensaje.toString(),
                      color: "success",
                    },
                    idAdmissionToCert: data.admision.id_admision,
                  });
                })
                .catch((error) => {
                  console.error(error);
                });
            } else {
              return response.text().then((text) => {
                console.error(text);
                throw new Error(text);
              });
            }
          })
          .catch((error) => {
            this.setState({
              openAlert: true,
              modalAlert: {
                title: "Error",
                message: error.toString(),
                color: "danger",
              },
            });
            this.setState({ disabled: false });
          });
      }
    }
  };

  getThirdAdmision = async (id) => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "tercero/ver/" + id, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //return data.contenido[0];
        this.setState({ costumer_data: data.contenido[0] });

        /* if (parseInt(data.contenido[0].tipo) == 1) {
                    this.loadPlans(data.contenido[0].id_tercero).then((plans) => {
                        this.setState({ plans: plans, activities: [], pertenece_estudio: false });
                    });
                } else {
                    this.setState({ pertenece_estudio: true });
                    this.loadClinicalStudio(data.contenido[0].id_tercero);
                } */
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  createPacientAdmision = async () => {
    //this.setState({ disabled: true }, () => {
    if (!this.validateForm()) {
      var dataCreateAll = {
        tipDoc: this.state.typeOfDocument,
        numDoc: this.state.documentNumber,
        ape1: this.state.firstLastName,
        ape2: this.state.secondLastName,
        nombres: this.state.names,
        sexo: this.state.gender,
        fec_nacimiento: moment(this.state.birthday).format("YYYY-MM-DD HH:MM:SS"),
        ocupacion: this.state.ocupation,
        direccion: {
          direccion: this.state.address,
          id_pais: this.state.country,
          id_dpto: this.state.department,
          id_ciudad: this.state.city,
          departamento: this.state.departments.filter(
            (department) => department.depcod === this.state.department
          )[0].depnom,
          ciudad: this.state.cities.filter(
            (city) => city.ciucod === this.state.city
          )[0].ciunom,
          id_pais_origen: this.state.countryOrigin,
        },
        telefono1: this.state.telephone1,
        telefono2: this.state.telephone2,
        celular: this.state.cellphone,
        correo: this.state.email,
        e_civil: this.state.civilStatus,
        id_raza: this.state.race,
        id_etnia: this.state.ethnicity,
        tiposangre: this.state.bloodType,
        zona: this.state.zone,
        fecha_admision: moment(this.state.date).format("YYYY-MM-DD"),
        hora_admision: moment(this.state.date).format("hh:mm a"),
        /*fecha_admision: moment(new Date()).format('YYYY-MM-DD'),
                hora_admision: moment(new Date()).format('hh:mm a'),*/
        id_regimen: this.state.regime,
        id_agenda: this.state.professionals.filter((professional) => {
          return professional.id_profesional === this.state.professional;
        })[0].id_agenda_activa,
        //title: this.state.activities.filter((activity) => { return activity.id_servicio === this.state.activity })[0].servicios,
        title: `${
          this.state.activitiesAppointment[0].servicios != undefined
            ? this.state.activitiesAppointment[0].servicios
            : ""
        }`,
        id_espacio: this.state.workspace,
        id_tercero: this.state.costumer,
        id_plan: this.state.plan,
        servicio: this.state.activitiesAppointment,
        //servicio: this.state.activity,
        tipo_consulta: this.state.typeConsult,
        causa_externa: this.state.externalCause,
        remitente: this.state.medico_remitente,
        peso: this.state.weight,
        talla: this.state.height,
        imc: this.state.imc,
        caidas: this.state.caidas,
        requerimientos_especiales: this.state.requerimientos_especiales,
        observacion: this.state.observacion,
        rango_regimen: this.state.rangeLevelRegime,
        tipo_usuario_salud: this.state.typeOfUser,
        remitente_medicos: this.state.referringDoctors,
        id_sede: this.state.workplaceSelected,
        pertenece_estudio: this.state.pertenece_estudio,
        via_ingreso: this.state.viaIngreso,
      };

      if (this.state.companion === "Si") {
        dataCreateAll.acompañantes = this.state.companions.map((companion) => {
          return {
            num_documento: companion.number,
            rol: companion.typeCompanion[0],
            nombre: companion.name,
            tel1: companion.firstTelephone,
            tel2: companion.secondTelephone,
            parentesco: companion.relationship,
          };
        });
      } else {
        dataCreateAll.acompañantes = this.state.companions;
      }

      dataCreateAll.representante_legal = this.state.represent.map((repre) => {
        return {
          num_documento: repre.number,
          nombre_completo: repre.name,
          telefono1: repre.firstTelephone,
          telefono2: repre.secondTelephone,
          parentesco: repre.relationship,
        };
      });

      dataCreateAll.codigo_autorizacion = this.state.authorization;
      dataCreateAll.num_afiliacion = this.state.affiliation;

      //Citas Adicionales
      dataCreateAll.citas_adicionales =
        this.state.confirmedAdditionalAppointments;
      dataCreateAll.nombre_fase_inicial = this.state.nameInitialPhase;
      dataCreateAll.firma_paciente = this.state.signaturePatient;
      dataCreateAll.codigo_validacion = this.state.validationCode;

      let usuario = JSON.parse(sessionStorage.getItem("usuario"));
      dataCreateAll.id_usuario = usuario.id_usuario;

      await fetch(process.env.REACT_APP_PUBLIC_URL + "admision/createall", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataCreateAll),
      })
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response
              .json()
              .then((data) => {
                if (this.state.costumer_data.recibos_cero_admitir) {
                  this.createReceipt(data.admision);
                }
                this.setState({
                  disabled: true,
                  idAdmissionToCert: data.admision.id_admision,
                });
                this.setState({
                  successStatus: 1,
                  openAlert: true,
                  modalAlert: {
                    title: "Admisión creada",
                    message: "Admisión creada Correctamente",
                    color: "success",
                  },
                });
              })
              .catch((error) => {
                console.error(error);
              });
          } else {
            return response.text().then((text) => {
              throw new Error(text);
            });
          }
        })
        .catch((error) => {
          this.setState({
            openAlert: true,
            modalAlert: {
              title: "Error",
              message: error.toString(),
              color: "danger",
            },
          });
          console.error(error);
        });
    } else {
      this.setState({ disabled: false });
    }
    //})
  };

  //Recibo de Caja CON PAGOS
  createReceipt = async (admision) => {
    let id_admisionToCreateReceipt = !!admision ? admision.id_admision : null;
    let dataCitaInfoSentToCreateReceipt =
      await this.loadDataCitaToCreateReceipt(admision.id_cita);
    let servicesToSent = !!dataCitaInfoSentToCreateReceipt
      ? dataCitaInfoSentToCreateReceipt.servicios.servicios
      : [];
    let typeRegimeThird = !!this.state.costumer_data
      ? this.state.costumer_data.id_regimen
      : null;
    let idThird = !!this.state.costumer_data
      ? this.state.costumer_data.id_tercero
      : null;
    let idPlan = !!dataCitaInfoSentToCreateReceipt
      ? dataCitaInfoSentToCreateReceipt.idPlan
      : null;
    let historyPatientSend = !!dataCitaInfoSentToCreateReceipt
      ? dataCitaInfoSentToCreateReceipt.id_historia
      : null;
    let medicinesToSend = !!dataCitaInfoSentToCreateReceipt
      ? this.loadMedicines(dataCitaInfoSentToCreateReceipt.servicios.servicios)
      : null;
    let clinicaInfo = JSON.parse(sessionStorage.getItem("clinica"));
    let isItAValidReceipt = clinicaInfo.hasOwnProperty("recibos_cero")
      ? clinicaInfo.recibos_cero
      : false;
    let valueReceipt = servicesToSent.reduce((acc, cur) => {
      let valueCostMedicines = cur.medicamentos
        ? cur.medicamentos.reduce(
            (accMed, curMed) => accMed + parseFloat(curMed.costo),
            0
          )
        : 0;
      return acc + valueCostMedicines + parseFloat(cur.costo);
    }, 0);
    if (
      !!id_admisionToCreateReceipt &&
      !!servicesToSent &&
      !!typeRegimeThird &&
      !!idPlan &&
      !!historyPatientSend &&
      !!medicinesToSend
    ) {
      let paymentType = "Efectivo";
      let medio_pago = [{ medio: "Efectivo", monto: 0 }];

      let usuario =
        sessionStorage.getItem("usuario") != undefined &&
        sessionStorage.getItem("usuario") != null
          ? sessionStorage.getItem("usuario")
          : null;
      let id_usuario = usuario != null ? JSON.parse(usuario).id_usuario : null;

      let data = {
        id_historia: historyPatientSend,
        id_admision: parseInt(id_admisionToCreateReceipt),
        fecha_emision: moment(new Date()).format("YYYY/MM/DD HH:mm:ss"),
        forma_pago: paymentType,
        medio_pago: medio_pago,
        tipo_pago: "COPAGO",
        valor_paciente:
          parseInt(typeRegimeThird) === 1
            ? valueReceipt
              ? valueReceipt
              : 0
            : 0,
        moneda: "COP",
        servicios: servicesToSent,
        id_tercero: idThird,
        id_plan: idPlan,
        tipo: parseInt(
          typeRegimeThird
        ) /* type: 1-Particular,2-Subsidiado,3-Contributivo,4-Regimen Especial,5-Contributivo Complementario,6-SOAT*/,
        id_usuario: id_usuario,
        medicamentos: medicinesToSend,
        valido: isItAValidReceipt,
      };
      //console.log("reciboscaja/create", data);
      await fetch(process.env.REACT_APP_PUBLIC_URL + "reciboscaja/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          console.log("Recibo de caja creado con exito!");
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  loadDataCitaToCreateReceipt = (id_cita) => {
    var data = { id_cita: id_cita };
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "agenda/consultarpaciente", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.existe) {
            resolve(data.contenido);
          }
        })
        .catch((error) => {
          resolve(error);
          console.error("Error:", error);
        });
    });
  };

  loadMedicines = (services) => {
    let medicinesArr = [];
    for (let i = 0; i < services.length; i++) {
      if (
        services[i].medicamentos != undefined &&
        services[i].medicamentos != null
      ) {
        for (let j = 0; j < services[i].medicamentos.length; j++) {
          //En los medicamentos guarda el Servicio que lo requiere para futuras gestiones con la Factura
          services[i].medicamentos[j].id_servicio = services[i].id_servicio;
          services[i].medicamentos[j].nombre_servicio = services[i].nombre;
          services[i].medicamentos[j].costo_total =
            parseFloat(services[i].medicamentos[j].costo) *
            parseFloat(services[i].medicamentos[j].numero_unidades);
          medicinesArr.push(services[i].medicamentos[j]);
        }
      }
    }
    return medicinesArr;
  };

  updateAdmission = () => {
    /*if(!this.validateForm()){
            Promise.all([this.fetchAdmission(), this.fetchAdmissionPatient()]).then((result)=>{
                console.log(result);
            })
        */
    //this.fetchAdmission();
    if (!this.validateForm()) {
      this.fetchAdmissionPatient();
    }
  };

  fetchAdmission = () => {
    var dataAdmission = {
      fecha: moment(this.state.date).format("DD-MM-YYYY"),
      hora: moment(this.state.date).format("HH:MM A"),
      id_admision: this.props.dataPatient.id_admision,
    };
    console.log(dataAdmission);

    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "admision/update", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataAdmission),
      })
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          console.log(data);
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  fetchAdmissionPatient = () => {
    var dataAdmissionPatient = {
      id_admision: parseInt(this.props.dataPatient.id_admision),
      id_historia: this.state.id_history,
      apellido1: this.state.firstLastName,
      apellido2: this.state.secondLastName,
      nombres: this.state.names,
      fecha_nac: moment(this.state.birthday).format("MM/DD/YYYY"),
      direccion: this.state.address,
      tel_fijo: this.state.telephone1,
      celular: this.state.cellphone,
      correo: this.state.email,
      id_regimen: this.state.regime,
    };

    if (this.state.companion === "Si") {
      dataAdmissionPatient.acompanantes = this.state.companions.map(
        (companion) => {
          return {
            num_documento: companion.number,
            rol: companion.typeCompanion[0],
            nombre: companion.name,
            tel1: companion.firstTelephone,
            tel2: companion.secondTelephone,
            parentesco: companion.relationship,
          };
        }
      );
    }
    console.log(dataAdmissionPatient);

    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "admision/updatepac", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataAdmissionPatient),
      })
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          console.log(data);
          resolve(data);
        })
        .catch((error) => {
          console.error("Error:", error);
          reject(error);
        });
    });
  };

  addDataCompanion = (companion) => {
    var companions = this.state.companions;
    companions.push(companion);
    this.setState({ companions: companions });
  };

  removeDataCompanion = () => {
    var companions = this.state.companions;
    companions.pop();
    this.setState({ companions: companions });
  };

  handlerCompanions = (index, companion) => {
    var companions = this.state.companions;
    companions[index] = companion;
    this.setState({ companions: companions });
  };

  handlerDocumentNumberCompanion = (index, number) => {
    var companions = this.state.companions;
    companions[index].number = number;
    this.setState({ companions: companions });
  };

  handlerNameCompanion = (index, name) => {
    var companions = this.state.companions;
    companions[index].name = name.toUpperCase();
    this.setState({ companions: companions });
  };

  handlerFirstTelephoneCompanion = (index, firstTelephone) => {
    var companions = this.state.companions;
    companions[index].firstTelephone = firstTelephone;
    this.setState({ companions: companions });
  };

  handlerSecondTelephoneCompanion = (index, secondTelephone) => {
    var companions = this.state.companions;
    companions[index].secondTelephone = secondTelephone;
    this.setState({ companions: companions });
  };

  handlerRelationshipCompanion = (index, relationship) => {
    var companions = this.state.companions;
    companions[index].relationship = relationship;
    this.setState({ companions: companions });
  };

  handlerTypeCompanion = (index, typeCompanion) => {
    var companions = this.state.companions;
    companions[index].typeCompanion = typeCompanion;
    this.setState({ companions: companions });
  };

  addDataRepresent = (repre) => {
    var represent = this.state.represent;
    represent.push(repre);
    this.setState({ represent: represent });
  };

  removeDataRepresent = () => {
    var represent = this.state.represent;
    represent.pop();
    this.setState({ represent: represent });
  };

  handlerRepresent = (index, repre) => {
    var represent = this.state.represent;
    represent[index] = repre;
    this.setState({ represent: represent });
  };

  handlerDocumentNumberRepresent = (index, number) => {
    var represent = this.state.represent;
    represent[index].number = number;
    this.setState({ represent: represent });
  };

  handlerNameRepresent = (index, name) => {
    var represent = this.state.represent;
    represent[index].name = name.toUpperCase();
    this.setState({ represent: represent });
  };

  handlerFirstTelephoneRepresent = (index, firstTelephone) => {
    var represent = this.state.represent;
    represent[index].firstTelephone = firstTelephone;
    this.setState({ represent: represent });
  };

  handlerSecondTelephoneRepresent = (index, secondTelephone) => {
    var represent = this.state.represent;
    represent[index].secondTelephone = secondTelephone;
    this.setState({ represent: represent });
  };

  handlerRelationshipRepresent = (index, relationship) => {
    var represent = this.state.represent;
    represent[index].relationship = relationship;
    this.setState({ represent: represent });
  };

  handlerTypeRepresent = (index, typeCompanion) => {
    var represent = this.state.represent;
    represent[index].typeCompanion = typeCompanion;
    this.setState({ represent: represent });
  };

  handlerEditReq = (action) => {
    this.setState({ edit_reqEspeciales: action });
  };

  updateFallingRisk = async () => {
    let data = {
      id_admision: this.state.id_admision,
      caidas: this.state.caidas,
    };
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "admision/actualizar-riesgo-caida",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error(response.json());
        }
      })
      .then((data) => {
        this.setState({ edit_fallingRisk: false, disableFormFalling: true });
        this.setState({
          successStatus: 3,
          openAlert: true,
          modalAlert: {
            title: "Riesgo de Caida",
            message: "Riesgo de Caida actualizada con éxito",
            color: "success",
          },
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  handleNotificacion = () => {
    this.setState({ openAlertNoti: true });
    return;
  };

  /****************************************************************************************************************** */
  updatePatient = () => {
    let data = {
      ape1: this.state.firstLastName,
      ape2: this.state.secondLastName,
      nombres: this.state.names,
      sexo: this.state.gender,
      fec_nacimiento: moment(this.state.birthday).format('YYYY-MM-DD HH:mm:ss'),
      ocupacion: this.state.ocupation,
      direccion: {
        id_pais: this.state.country,
        id_pais_origen: this.state.countryOrigin,
        departamento: this.state.departments.filter(
          (department) => department.depcod === this.state.department
        )[0].depnom,
        id_departamento: this.state.department,
        ciudad: this.state.cities.filter(
          (city) => city.ciucod === this.state.city
        )[0].ciunom,
        id_ciudad: this.state.city,
        direccion: this.state.address,
      },
      telefono1: this.state.telephone1,
      telefono2: this.state.telephone2,
      celular: this.state.cellphone,
      correo: this.state.email,
      e_civil: this.state.civilStatus,
      id_etnia: this.state.ethnicity,
      id_raza: this.state.race,
      id_poblacion_vulnerable: this.state.poblacionVulnerable !== "Ninguna" ? this.state.poblacionVulnerable : null,
      id_regimen: this.state.regime,
      tipo_sangre: this.state.bloodType,
      //fec_ingreso: this.state.fec_ingreso,
      id_paciente: this.state.id_patient,
      id_historia: this.state.id_history,
      zona: this.state.zone,
      num_documento: this.state.documentNumber,
      tipo_documento: this.state.typeOfDocument,
    };

    fetch(process.env.REACT_APP_PUBLIC_URL + "paciente/update", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        }
      })
      .then((data) => {
        console.log(data);
        this.setState({
          openAlert: true,
          modalAlert: {
            message: "Paciente actualizado con exito",
            color: "success",
            title: "Exitoso!",
          },
          editInfoPatient: true,
          disabledInput: true,
          disabled: false,
          onUpdate: false,
        });
        this.setState({ openAlertNoti: false });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  //Valida el Tipo de Consulta

  changeRegimenPlanAndServices = async () => {
    if (this.state.activitiesAppointment.length === 0) {
      alert("Debe de seleccionar al menos un servicio");
      return;
    }
    let dataSend = {
      id_cita:
        typeof this.props.dataPatient.id_cita !== "undefined"
          ? this.props.dataPatient.id_cita
          : this.props.dataPatient.dataPatient.id_cita,
      id_tercero: this.state.costumer_data.id_tercero,
      id_plan: this.state.plan,
      actividades: this.state.activitiesAppointment,
      remitente: this.state.medico_remitente,
      causa_externa: this.state.externalCause,
      finalidad_cita: this.state.typeConsult,
      via_ingreso: this.state.viaIngreso,
      id_regimen: this.state.regime,
      id_historia: this.state.id_history,
    };
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "admision/actualizar-datos-regimen",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Server Error");
        }
      })
      .then((data) => {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Regimen",
            message: data.mensaje.toString(),
            color: "warning",
          },
        });
        this.setState({ editRegimenAndServices: false });
      })
      .catch((error) => {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Regimen",
            message: "Ha ocurrido un error en el Servidor",
            color: "error",
          },
        });
        console.error("Error:", error);
      });
  };

  changeInfoAislamiento = async () => {
    if (!this.validateAislamiento()) {
      let dataAislamiento = {
        id_admision:
          typeof this.props.dataPatient.id_admision !== "undefined"
            ? this.props.dataPatient.id_admision
            : this.props.dataPatient.dataPatient.id_admision,
        fechaIngreso: moment(this.state.fechaIngreso).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        numHabitacion: this.state.numHabitacion,
        descripcionHabitacion: this.state.descripcionHabitacion,
        dietaPaciente: this.state.dietaPaciente,
        id_habitacion: this.state.id_habitacion,
        fechaEgreso: moment(this.state.fechaEgreso).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        diagnosticAislamiento: this.state.diagnosticAislamiento?.id,
      };
      let usuario = JSON.parse(sessionStorage.getItem("usuario"));
      dataAislamiento.id_usuario = usuario.id_usuario;
      await fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "admision/actualizar-datos-aislamiento",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(dataAislamiento),
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Server Error");
          }
        })
        .then((data) => {
          this.setState({
            openAlert: true,
            modalAlert: {
              title: "Datos de Aislamiento",
              message: "Información actualizada correctamente",
              color: "success",
            },
          });
          this.setState({ editInfoAdmission: false });
        })
        .catch((error) => {
          this.setState({
            openAlert: true,
            modalAlert: {
              title: "Datos de aislamiento",
              message: "Ha ocurrido un error en el Servidor",
              color: "danger",
            },
          });
          console.error("Error:", error);
        });
    }
  };

  changeInfoAdmission = async () => {
    let dataSend = {
      id_admision:
        typeof this.props.dataPatient.id_admision !== "undefined"
          ? this.props.dataPatient.id_admision
          : this.props.dataPatient.dataPatient.id_admision,
      fecha: moment(this.state.date).format("YYYY-MM-DD"),
      hora: moment(this.state.date).format("hh:mm a"),
      rango_regimen: this.state.rangeLevelRegime,
      codigo_autorizacion: this.state.authorization,
      tipo_cita: this.state.typeConsult,
      causa_externa: this.state.externalCause,
      remitente: this.state.medico_remitente,
      tipo_usuario_salud: this.state.typeOfUser,
      codigo_validacion: this.state.validationCode,
      remitente_medicos: this.state.referringDoctors,
      via_ingreso: this.state.viaIngreso,
    };
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "admision/update-datos-generales",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Server Error");
        }
      })
      .then((data) => {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Datos Admisión",
            message: "Información actualizada correctamente",
            color: "success",
          },
        });
        this.setState({ editInfoAdmission: false });
      })
      .catch((error) => {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Regimen",
            message: "Ha ocurrido un error en el Servidor",
            color: "error",
          },
        });
        console.error("Error:", error);
      });
  };

  changeCompanionsLegalRepresent = async () => {
    let dataSend = {
      id_admision: this.props.dataPatient.id_admision,
    };

    if (this.state.companion === "Si") {
      dataSend.acompañantes = this.state.companions.map((companion) => {
        return {
          num_documento: companion.number,
          rol: companion.typeCompanion[0],
          nombre: companion.name,
          tel1: companion.firstTelephone,
          tel2: companion.secondTelephone,
          parentesco: companion.relationship,
        };
      });
    } else {
      dataSend.acompañantes = this.state.companions;
    }

    dataSend.representante_legal = this.state.represent.map((repre) => {
      return {
        num_documento: repre.number,
        nombre_completo: repre.name,
        telefono1: repre.firstTelephone,
        telefono2: repre.secondTelephone,
        parentesco: repre.relationship,
      };
    });

    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "admision/update-acompanante-representante",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Server Error");
        }
      })
      .then((data) => {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Representante Legal",
            message:
              "Acompañante y/o representante legal actualizado con exito",
            color: "success",
          },
        });
        this.setState({ editLegalRepresent: false });
      })
      .catch((error) => {
        this.setState({
          openAlert: true,
          modalAlert: {
            title: "Representante Legal",
            message: "Ha ocurrido un error en el servidor",
            color: "danger",
          },
        });
        console.error("Error:", error);
      });
  };

  onToggleModal = () => {
    switch (this.state.modalAlert.color) {
      case "success":
        //this.finishSuccessProcessAdmision();
        this.setState({ successStatus: null });
        break;
      case "warning":
        this.setState({ creationProcess: null });
        break;
    }
    this.setState({ openAlert: !this.state.openAlert });
  };

  onOkModal = () => {
    switch (this.state.modalAlert.color) {
      case "success":
        this.finishSuccessProcessAdmision();
        break;
      case "warning":
        console.log("Warning");
        this.preFinishSuccessAdmision();
        break;
    }
    this.setState({ openAlert: !this.state.openAlert });
  };

  verifyColorFallingRisk = () => {
    let color = "";
    if (this.state.caidas.riesgo == "Alto") {
      color = "#F71C06";
    } else if (this.state.caidas.riesgo == "Bajo") {
      color = "#40F400";
    } else if (this.state.caidas.riesgo == "Medio") {
      color = "#F7EF06";
    } else {
      color = "#6F6964";
    }
    this.setState({ colorFallingRisk: color });
    return color;
  };

  preFinishSuccessAdmision = async () => {
    switch (this.state.creationProcess) {
      case 1:
        await this.sendDataFormAdmission();
        break;
      case 2:
        await this.createPacientAdmision();
        break;
    }
  };

  finishSuccessProcessAdmision = () => {
    //const profile = JSON.parse(sessionStorage.getItem('perfil'));
    const profile = sessionStorage.getItem("perfil");
    const urlLogo = sessionStorage.getItem("logoURL");

    if (profile == "" || profile == "null") {
      profile = JSON.parse(sessionStorage.getItem("perfil"));
    }

    let foundProfessional = this.state.professionals.find(
      (prof) => prof.id_profesional === this.state.professional
    );
    let namePatient =
      this.state.names +
      " " +
      this.state.firstLastName +
      " " +
      this.state.secondLastName;
    let regime = this.state.regimes.find(
      (reg) => reg.id_regimen === this.state.regime
    );
    let infoAdmission = {
      admision: {
        codigo_validacion: this.state.validationCode,
        codigo_autorizacion: this.state.authorization,
      },
      tipo_sangre: this.state.bloodType,
    };
    let plans = this.state.plans;
    let planSelected = plans.find(
      (plan) => plan.id_plan === parseInt(this.state.plan)
    );
    let dataSendCertAdmission = {
      today: new Date(),
      urlLogo: urlLogo,
      names: namePatient,
      gender: this.state.gender,
      typeOfDocument: this.state.typeOfDocument,
      documentNumber: this.state.documentNumber,
      servName:
        this.state.activitiesAppointment && this.state.activitiesAppointment[0]
          ? this.state.activitiesAppointment[0].nombre
          : "",
      //servName: this.state.activitiesAppointment[0]?.nombre || "",
      profile: profile,
      id_admision: !!this.state.idAdmissionToCert
        ? this.state.idAdmissionToCert
        : "",
      fecha: moment(this.state.date).format("DD-MM-YYYY"),
      hora: moment(this.state.date).format("hh:mm a"),
      birthday: this.state.birthday,
      age: this.state.age,
      celular: this.state.cellphone,
      telefono: this.state.telephone1,
      direccion: this.state.address,
      professional: !!foundProfessional ? foundProfessional : null,
      servicios: this.state.activitiesAppointment,
      id_profesional: this.state.professional,
      regime: !!regime ? regime.regimen : "",
      thirdName:
        this.state.costumer_data && this.state.costumer_data.nombre
          ? this.state.costumer_data.nombre
          : "",
      //thirdName: this.state.costumer_data.nombre || "",
      infoAdmission: infoAdmission,
      from: "ADM",
      plansName: !!planSelected ? planSelected?.nombre : "",
    };
    switch (this.state.successStatus) {
      case 1: //Admision que se creo con una Cita Previa
        AdmisionSocket.updateSystemListAdmision();
        history.push({
          pathname: process.env.PUBLIC_URL + "/assitencial/admissions",
          state: {
            date: moment(new Date()).format("YYYY-MM-DD"),
            openPDFCertAdmission: true,
            dataSendCertAdmission,
          },
        });
        break;
      case 2:
        history.push({
          pathname: process.env.PUBLIC_URL + "/assitencial/admissions",
          state: {
            dataPatient: this.props.dataPatient,
            dataSendCertAdmission,
          },
        });
        break;
      case 3:
        this.setState({ openAlert: !this.state.openAlert });
        break;
    }
  };

  createAdmisionProcess = async (opt) => {
    if (!this.validateForm()) {
      await this.validateAutorizationCodeExist()
        .then((res) => {
          let advertenciaAutorizacion = false;
          if (
            res.existe === true &&
            this.state.authorization !== null &&
            this.state.authorization !== undefined &&
            this.state.authorization !== ""
          ) {
            if (this.state.admisionFather == null) {
              advertenciaAutorizacion = true;
            }
          }
          let mensaje = "Esta completamente seguro de crear esta admisión?";
          if (
            advertenciaAutorizacion &&
            res.mensaje == "El Codigo de Autorización ya existe"
          ) {
            mensaje =
              "El Codigo de Autorización ya existe, esta completamente seguro de crear esta admisión?";
          } else {
            mensaje =
              "Esta completamente seguro de crear esta admisión con el código de autorización ingresado?";
          }
          switch (opt) {
            case 1: //Admision que es generada con base a una Cita Medica
              this.setState({
                creationProcess: 1,
                openAlert: true,
                modalAlert: {
                  title: "Advertencia",
                  message: mensaje,
                  color: "warning",
                },
              });
              break;
            case 2: //Admision que es creada desde el Modulo de Admisiones
              this.setState({
                creationProcess: 2,
                openAlert: true,
                modalAlert: {
                  title: "Advertencia",
                  message: mensaje,
                  color: "warning",
                },
              });
              break;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  validateAutorizationCodeExist = () => {
    return new Promise((resolve, reject) => {
      fetch(
        process.env.REACT_APP_PUBLIC_URL +
          `admision/validar-codigo-autorizacion?codigo_autorizacion=${this.state.authorization}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Server Error");
          }
        })
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          this.setState({
            openAlert: true,
            modalAlert: {
              title: "Error",
              message:
                "Ha ocurrido un error validando el codigo de autorización",
              color: "danger",
            },
          });
          reject(error);
        });
    });
  };

  handlerConfirmedAdditionalAppointments = (value) => {
    if (value.detalle_servicio.requiere_multicitas != true) {
      this.setState({
        confirmedAdditionalAppointments: [
          ...this.state.confirmedAdditionalAppointments.filter(
            (confCita) => value.id_servicio != confCita.id_servicio
          ),
          value,
        ],
      });
    } else {
      console.log("valueDATA", value);
      this.setState({
        confirmedAdditionalAppointments: [
          ...this.state.confirmedAdditionalAppointments,
          value,
        ],
      });
    }
  };

  completeHandlerConfirmedAddionalAppointments = (arr) => {
    this.setState({ confirmedAdditionalAppointments: arr });
  };

  changeNameInitialPhase = (nameInitialPhase) => {
    this.setState({ nameInitialPhase: nameInitialPhase });
  };

  validateShowInfoClinic = () => {
    let clinica = JSON.parse(sessionStorage.getItem("clinica"));

    this.setState({
      showSpecialReq: clinica.hasOwnProperty("solicitar_req_especiales")
        ? clinica.solicitar_req_especiales
        : false,
      showFeminineInfo: clinica.hasOwnProperty("info_femenina")
        ? clinica.info_femenina
        : false,
      showFallingRisks: clinica.hasOwnProperty("solicitar_riesdo_caida")
        ? clinica.solicitar_riesdo_caida
        : false,
    });
  };

  updateObservation = async (id_cita) => {
    let dataSend = {
      id_cita,
      observacion: this.state.observacion,
    };

    await fetch(process.env.REACT_APP_PUBLIC_URL + "cita/update-observ", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataSend),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({ observationFieldEdit: false });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  updateDisability = async () => {
    let dataSend = {
      id_admision: this.state.id_admision,
      id_historia: this.state.id_history,
    }    

    if(this.state.disability === "Si") {
      dataSend.discapacidad = {
        discapacidad: this.state.disability,
        discapacidades: this.state.selectedDisability,
      }
    }else{
      dataSend.discapacidad = {
        discapacidad: this.state.disability,
        discapacidades: [],
      }  
    } 

    await fetch(process.env.REACT_APP_PUBLIC_URL + "admision/updateDiscapacidad", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataSend),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {        
        this.setState({ edit_disability: false });
        this.setState({
          openAlert: true,
          modalAlert: {
            message: "Se ha actualizado la discapacidad correctamente",
            color: "success",
            title: "Exitoso!",
          }
        });
        this.setState({ openAlertDisability: false });

      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  handlerSendRefferingDoctor = () => {
    if (!!this.state.docRemAdd) {
      this.createRefferingProfessional(this.state.docRemAdd.trim());
    }
  };

  render() {
    const { classes } = this.props;

    {    console.log("disability",this.state.disability);}

    return (
      <Col>
        <CardBody>
          <div
            style={{
              border: "1px solid #CACDD1",
              borderRadius: 5,
              paddingBottom: "1em",
            }}
          >
            <div className="top_info_patient">
              <div style={{ margin: "1em 2em" }}>
                <h4>Datos basicos</h4>
              </div>

              <div className="info_patient">
                <div>
                  {this.state.age !== "" &&
                  this.state.birthday != null &&
                  this.state.birthday != undefined ? (
                    <h5>
                      {" "}
                      <b>Edad:</b> {this.state.age}{" "}
                    </h5>
                  ) : null}
                </div>
                <div style={{ margin: "0em 1em" }}>
                  {this.state.weight !== "" && this.state.weight !== null ? (
                    <h5>
                      {" "}
                      <b>Peso:</b> {this.state.weight} (kg)
                    </h5>
                  ) : null}
                </div>
                <div>
                  {this.state.height !== "" && this.state.height !== null ? (
                    <h5>
                      {" "}
                      <b>Talla:</b> {this.state.height} (cm)
                    </h5>
                  ) : null}
                </div>
              </div>

              {this.state.id_admision !== null &&
              this.state.id_admision !== undefined &&
              this.state.id_admision !== "" ? (
                <div style={{ margin: "1em 2em" }}>
                  <h4>
                    <b>
                      Admision No.{" "}
                      {this.props.dataPatient.id_admision !== null &&
                      this.props.dataPatient.id_admision !== undefined
                        ? this.props.dataPatient.id_admision
                        : this.state.id_admision}{" "}
                    </b>
                  </h4>
                </div>
              ) : null}
            </div>

            <Row style={{ margin: "0em 1em 0em 1em" }}>
              <Col md={3}>
                <TextField
                  required
                  //className={classes.date}
                  style={{ width: "100%" }}
                  id="document-number-standard-required"
                  label="N° de documento"
                  type="number"
                  value={this.state.documentNumber}
                  onChange={(e) => {
                    this.handlerDocumentNumber(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("documentNumber")
                      ? this.state.errors.documentNumber !== ""
                      : false
                  }
                  helperText={this.state.errors.documentNumber}
                  //disabled={typeof this.props.dataPatient.cita !== 'undefined'}
                  disabled={true}
                  //disabled={this.props.dataPatient.dataPatient !== null}
                />
              </Col>
              <Col md={3}>
                <FormControl
                  //className={classes.date}
                  style={{ width: "100%" }}
                  error={
                    this.state.errors.hasOwnProperty("typeOfDocument")
                      ? this.state.errors.typeOfDocument !== ""
                      : false
                  }
                >
                  <InputLabel required id="demo-simple-select-label">
                    Tipo de Documento
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="id-simple-select"
                    defaultValue={null}
                    value={this.state.typeOfDocument}
                    onChange={(event) => {
                      this.handlerTypeOfDocument(event.target.value);
                    }}
                    //disabled={this.props.dataPatient.dataPatient !== null}
                    disabled={this.state.disabledInput}
                    error={
                      this.state.errors.hasOwnProperty("typeOfDocument")
                        ? this.state.errors.typeOfDocument !== ""
                        : false
                    }
                  >
                    <MenuItem key={1} value={"TI"}>
                      TI-Tarjeta de Identidad
                    </MenuItem>
                    <MenuItem key={2} value={"CC"}>
                      CC-Cedula de Ciudadania
                    </MenuItem>
                    <MenuItem key={3} value={"PA"}>
                      PA-Pasaporte
                    </MenuItem>
                    <MenuItem key={4} value={"RC"}>
                      RC-Registro Civil
                    </MenuItem>
                    <MenuItem key={5} value={"CE"}>
                      CE-Cedula de Extranjeria
                    </MenuItem>
                    <MenuItem key={6} value={"MS"}>
                      MS-Menor sin Identificación
                    </MenuItem>
                    <MenuItem key={7} value={"AS"}>
                      AS-Adulto sin Identificación
                    </MenuItem>
                    <MenuItem key={8} value={"SC"}>
                      SC-Salvo Conducto
                    </MenuItem>
                    <MenuItem key={9} value={"CD"}>
                      CD-Carnet Diplomatico
                    </MenuItem>
                    <MenuItem key={10} value={"CN"}>
                      CN-Certificado de Nacido Vivo
                    </MenuItem>
                    <MenuItem key={11} value={"PE"}>
                      PE-Permiso Especial de Permanencia
                    </MenuItem>
					<MenuItem key={12} value={"PT"}>
                      PT-Permiso por Protección Temporal
                    </MenuItem>
                  </Select>
                  <FormHelperText>
                    {this.state.errors.typeOfDocument}
                  </FormHelperText>
                </FormControl>
              </Col>
              <Col md={3}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <ThemeProvider theme={defaultMaterialTheme}>
                    <KeyboardDatePicker
                      disableFuture
                      label="F. Nacimiento"
                      value={this.state.birthday}
                      disabled={this.state.disabledInput}
                      onChange={(date) => {
                        if (date !== null) {
                          if (date._isValid) {
                            this.handlerBirthDate(new Date(date));
                            this.calculateAge(date);
                          } else {
                            this.handlerBirthDate(new Date(date._i));
                            this.calculateAge(date._i);
                          }
                        } else {
                          this.handlerBirthDate(date);
                        }
                      }}
                      animateYearScrolling
                      format="DD/MM/YYYY"
                      autoOk={true}
                      //className={classes.date}
                      style={{ width: "100%" }}
                      error={
                        this.state.errors.hasOwnProperty("birthday")
                          ? this.state.errors.birthday !== ""
                          : false
                      }
                      helperText={this.state.errors.birthday}
                    />
                  </ThemeProvider>
                </MuiPickersUtilsProvider>
              </Col>
              <Col md={3}>
                {this.state.editInfoPatient ? (
                  <Button
                    size="sm"
                    color="primary"
                    onClick={() => {
                      //console.log(this.state.disabled);
                      this.setState({
                        disabledInput: false,
                        disabled: true,
                        onUpdate: true,
                        editInfoPatient: false,
                      });
                    }}
                    disabled={this.state.load}
                  >
                    Actualizar Paciente
                  </Button>
                ) : null}
              </Col>
            </Row>

            <Row style={{ margin: "0em 1em 0em 1em" }}>
              <Col md={3}>
                <TextField
                  required
                  //className={classes.date}
                  style={{ width: "100%" }}
                  id="names-standard-required"
                  label="Nombres"
                  type="text"
                  value={this.state.names}
                  onChange={(e) => {
                    this.handlerNames(e.target.value);
                  }}
                  //disabled={typeof this.props.dataPatient.cita !== 'undefined'}
                  disabled={this.state.disabledInput}
                  error={
                    this.state.errors.hasOwnProperty("names")
                      ? this.state.errors.names !== ""
                      : false
                  }
                  helperText={this.state.errors.names}
                />
              </Col>
              <Col md={3}>
                <TextField
                  required
                  //className={classes.date}
                  style={{ width: "100%" }}
                  id="first-last-name-standard-required"
                  label="Primer Apellido"
                  type="text"
                  value={this.state.firstLastName}
                  disabled={this.state.disabledInput}
                  onChange={(e) => {
                    this.handlerFirstLastName(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("firstLastName")
                      ? this.state.errors.firstLastName !== ""
                      : false
                  }
                  helperText={this.state.errors.firstLastName}
                />
              </Col>
              <Col md={3}>
                <TextField
                  //className={classes.date}
                  style={{ width: "100%" }}
                  id="second-last-name-standard-required"
                  label="Segundo Apellido"
                  type="text"
                  value={this.state.secondLastName}
                  disabled={this.state.disabledInput}
                  onChange={(e) => {
                    this.handlerSecondLastName(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("secondLastName")
                      ? this.state.errors.secondLastName !== ""
                      : false
                  }
                  helperText={this.state.errors.secondLastName}
                />
              </Col>
              <Col md={3}>
                <FormControl
                  //className={classes.date}
                  style={{ width: "100%" }}
                  error={
                    this.state.errors.hasOwnProperty("gender")
                      ? this.state.errors.gender !== ""
                      : false
                  }
                >
                  <InputLabel required id="demo-simple-select-label">
                    Genero
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="id-simple-select"
                    defaultValue={null}
                    value={this.state.gender}
                    disabled={this.state.disabledInput}
                    onChange={(event) => {
                      this.handlerGender(event.target.value);
                    }}
                    error={
                      this.state.errors.hasOwnProperty("gender")
                        ? this.state.errors.gender !== ""
                        : false
                    }
                  >
                    <MenuItem key={1} value={"Masculino"}>
                      Masculino
                    </MenuItem>
                    <MenuItem key={2} value={"Femenino"}>
                      Femenino
                    </MenuItem>
                    <MenuItem key={3} value={"Binario"}>
                      Binario
                    </MenuItem>
                  </Select>
                  <FormHelperText>{this.state.errors.gender}</FormHelperText>
                </FormControl>
              </Col>
            </Row>

            <Row style={{ margin: "0em 1em 0em 1em" }}>
              <Col md={3}>
                <Row>
                  <Col>
                    <TextField
                      required
                      //className={classes.date}
                      style={{ width: "100%" }}
                      id="email-standard-required"
                      label="E-mail"
                      type="email"
                      value={this.state.email !== null ? this.state.email : ""}
                      disabled={this.state.disabledInput}
                      onChange={(e) => {
                        this.handlerEmail(e.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("email")
                          ? this.state.errors.email !== ""
                          : false
                      }
                      helperText={this.state.errors.email}
                    />
                  </Col>
                  {/* <Col>
                    <FormControlLabel
                      style={{ paddingRight: 0 }}
                      control={
                        <Checkbox
                          disabled={this.state.disabledInput}
                          color="primary"
                          onChange={(event) => {
                            if (event.target.checked) {
                              this.setState({ email: "NOTIENE@CORREO.COM" });
                            } else {
                              this.setState({ email: " " });
                            }
                          }}
                        />
                      }
                      label="No tiene"
                    />
                  </Col> */}
                </Row>
              </Col>
              <Col md={3}>
                <TextField
                  //className={classes.date}
                  style={{ width: "100%" }}
                  id="first-telephone-standard-required"
                  label="Teléfono 1"
                  type="text"
                  value={this.state.telephone1}
                  disabled={this.state.disabledInput}
                  onChange={(e) => {
                    this.handlerTelephone1(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("telephone")
                      ? this.state.errors.telephone !== ""
                      : false
                  }
                  helperText={this.state.errors.telephone}
                />
                {/* <TextField
                                    className={classes.date}
                                    id="second-telephone-standard-required"
                                    label="Teléfono 2"
                                    type="text"
                                    value={this.state.telephone2}
                                    disabled={this.state.disabledInput}
                                    onChange={(e) => {
                                        this.handlerTelephone2(e.target.value);
                                    }}
                                /> */}
              </Col>
              <Col md={3}>
                <TextField
                  required
                  //className={classes.date}
                  style={{ width: "100%" }}
                  id="cellphone-standard-required"
                  label="Celular"
                  type="text"
                  value={this.state.cellphone}
                  disabled={this.state.disabledInput}
                  onChange={(e) => {
                    this.handlerCellphone(e.target.value);
                  }}
                  error={
                    this.state.errors.hasOwnProperty("cellphone")
                      ? this.state.errors.cellphone !== ""
                      : false
                  }
                  helperText={this.state.errors.cellphone}
                />
              </Col>
              <Col md={3}>
                <FormControl
                  //className={classes.date}
                  style={{ width: "100%" }}
                  error={
                    this.state.errors.hasOwnProperty("regime")
                      ? this.state.errors.regime !== ""
                      : false
                  }
                >
                  <InputLabel id="regime-status-select-label">
                    Regimen
                  </InputLabel>
                  <Select
                    labelId="regime-select-label"
                    id="id-simple-select"
                    value={this.state.regime}
                    disabled={false}
                    onChange={(event) => {
                      this.handlerRegime(event.target.value);
                    }}
                    error={
                      this.state.errors.hasOwnProperty("regime")
                        ? this.state.errors.regime !== ""
                        : false
                    }
                  >
                    {this.state.regimes.map((regime) => {
                      return (
                        <MenuItem
                          key={regime.id_regimen}
                          value={regime.id_regimen}
                        >
                          {regime.regimen}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText>{this.state.errors.regime}</FormHelperText>
                </FormControl>
              </Col>
            </Row>
          </div>
          <div
            style={{
              border: "1px solid #CACDD1",
              borderRadius: 5,
              marginTop: 5,
              paddingBottom: "1em",
            }}
          >
            <div style={{ margin: "1em 0em 1em 2em" }}>
              <h4>Datos Ubicación</h4>
            </div>
            <Row style={{ margin: "0em 1em 0em 1em" }}>
              <Col md={3}>
                <FormControl
                  //className={classes.date}
                  style={{ width: "100%" }}
                  error={
                    this.state.errors.hasOwnProperty("country")
                      ? this.state.errors.country !== ""
                      : false
                  }
                >
                  <InputLabel required id="country-status-select-label">
                    País
                  </InputLabel>
                  <Select
                    labelId="country-select-label"
                    id="id-simple-select"
                    value={this.state.country}
                    disabled={this.state.disabledInput}
                    onChange={(event) => {
                      this.handlerCountry(event.target.value);
                    }}
                    error={
                      this.state.errors.hasOwnProperty("country")
                        ? this.state.errors.country !== ""
                        : false
                    }
                  >
                    {this.state.countries.map((country) => {
                      return (
                        <MenuItem key={country.paicod} value={country.paicod}>
                          {country.painom}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText>{this.state.errors.country}</FormHelperText>
                </FormControl>
              </Col>
              <Col md={3}>
                <FormControl
                  //className={classes.date}
                  style={{ width: "100%" }}
                  error={
                    this.state.errors.hasOwnProperty("department")
                      ? this.state.errors.department !== ""
                      : false
                  }
                >
                  <InputLabel required id="department-status-select-label">
                    Departamento
                  </InputLabel>
                  <Select
                    labelId="department-select-label"
                    id="id-simple-select"
                    defaultValue={null}
                    value={this.state.department}
                    disabled={this.state.disabledInput}
                    onChange={(event) => {
                      this.handlerDepartment(event.target.value);
                    }}
                    error={
                      this.state.errors.hasOwnProperty("department")
                        ? this.state.errors.department !== ""
                        : false
                    }
                  >
                    {this.state.departments.map((department) => {
                      return (
                        <MenuItem key={department.id} value={department.depcod}>
                          {department.depnom}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText>
                    {this.state.errors.department}
                  </FormHelperText>
                </FormControl>
              </Col>
              <Col md={3}>
                <FormControl
                  //className={classes.date}
                  style={{ width: "100%" }}
                  error={
                    this.state.errors.hasOwnProperty("city")
                      ? this.state.errors.city !== ""
                      : false
                  }
                >
                  <InputLabel required id="city-status-select-label">
                    Ciudad
                  </InputLabel>
                  <Select
                    labelId="city-select-label"
                    id="id-simple-select"
                    defaultValue={null}
                    value={this.state.city}
                    disabled={this.state.disabledInput}
                    onChange={(event) => {
                      this.handlerCity(event.target.value);
                    }}
                    error={
                      this.state.errors.hasOwnProperty("city")
                        ? this.state.errors.city !== ""
                        : false
                    }
                  >
                    {this.state.cities.map((city) => {
                      return (
                        <MenuItem key={city.id} value={city.ciucod}>
                          {city.ciunom}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText>{this.state.errors.city}</FormHelperText>
                </FormControl>
              </Col>
              <Col md={3}>
                <Row>
                  <Col>
                    <TextField
                      required
                      //className={classes.date}
                      style={{ width: "100%" }}
                      id="address-standard-required"
                      label="Dirección"
                      type="text"
                      value={this.state.address}
                      disabled={this.state.disabledInput}
                      onChange={(e) => {
                        this.handlerAddress(e.target.value);
                      }}
                      error={
                        this.state.errors.hasOwnProperty("address")
                          ? this.state.errors.address !== ""
                          : false
                      }
                      helperText={this.state.errors.address}
                    />
                  </Col>
                  <Col>
                    <FormControl
                      //className={classes.date}
                      style={{ width: "100%" }}
                      error={
                        this.state.errors.hasOwnProperty("zone")
                          ? this.state.errors.zone !== ""
                          : false
                      }
                    >
                      <InputLabel id="demo-simple-select-label">
                        Zona
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="id-simple-select"
                        defaultValue={null}
                        value={this.state.zone}
                        error={
                          this.state.errors.hasOwnProperty("zone")
                            ? this.state.errors.zone !== ""
                            : false
                        }
                        onChange={(event) => {
                          this.setState({ zone: event.target.value });
                        }}
                        disabled={this.state.disabledInput}
                      >
                        <MenuItem key={1} value={"R"}>
                          RURAL
                        </MenuItem>
                        <MenuItem key={2} value={"U"}>
                          URBANA
                        </MenuItem>
                      </Select>
                    </FormControl>
                    <FormHelperText>{this.state.errors.zone}</FormHelperText>
                  </Col>
                </Row>
              </Col>
              <Col md={3}>
                <FormControl
                  style={{ width: "100%" }}
                  error={
                    this.state.errors.hasOwnProperty("countryOrigin")
                      ? this.state.errors.countryOrigin !== ""
                      : false
                  }
                >
                  <InputLabel required id="country-origin-status-select-label">
                    País de Origen
                  </InputLabel>
                  <Select
                    labelId="country-origin-select-label"
                    id="id-simple-select"
                    value={this.state.countryOrigin}
                    disabled={this.state.disabledInput}
                    onChange={(event) => {
                      this.handlerCountryOrigin(event.target.value);
                    }}
                    error={
                      this.state.errors.hasOwnProperty("countryOrigin")
                        ? this.state.errors.countryOrigin !== ""
                        : false
                    }
                  >
                    {this.state.countries.map((country) => {
                      return (
                        <MenuItem key={country.paicod} value={country.paicod}>
                          {country.painom}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText>
                    {this.state.errors.countryOrigin}
                  </FormHelperText>
                </FormControl>
              </Col>
            </Row>
            <Row style={{ margin: "0em 1em 0em 1em" }}>
              <Col md={3}>
                {this.state.onUpdate ? (
                  <Fragment>
                    <Tooltip title="Actualizar Datos del Paciente">
                      <IconButton
                        aria-label="upload picture"
                        component="span"
                        disabled={this.state.disabledInput}
                        onClick={() => {
                          this.handleNotificacion();
                        }}
                      >
                        <SaveIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Cancelar Edición">
                      <IconButton
                        aria-label="upload picture"
                        component="span"
                        disabled={this.state.disabledInput}
                        onClick={() => {
                          this.setState({
                            editInfoPatient: true,
                            disabledInput: true,
                            disabled: false,
                            onUpdate: false,
                          });
                        }}
                      >
                        <BlockIcon />
                      </IconButton>
                    </Tooltip>
                  </Fragment>
                ) : null}
              </Col>
            </Row>
          </div>
          {this.state.openShowMore ? (
            <div
              style={{ margin: 10, color: "#4ce1b6", fontSize: 15 }}
              variant="contained"
              color="primary"
              onClick={() => {
                //this.loadDataPatient();
                this.setState({ openShowMore: false });
              }}
            >
              Ver Menos
            </div>
          ) : (
            <div
              style={{ margin: 10, color: "#4ce1b6", fontSize: 15 }}
              onClick={() => {
                //this.loadDataPatient();
                this.setState({ openShowMore: true });
              }}
            >
              Ver Más
            </div>
          )}
          {this.state.openShowMore ? (
            <React.Fragment>
              <div
                style={{
                  border: "1px solid #CACDD1",
                  borderRadius: 5,
                  marginTop: 5,
                  paddingBottom: "1em",
                }}
              >
                <div style={{ margin: "1em 0em 1em 2em" }}>
                  <h4>Datos adicionales</h4>
                </div>
                <Row style={{ margin: "0em 1em 0em 1em" }}>
                  <Col md={3}>
                    <Row>
                      <Col>
                        <FormControl
                          //className={classes.date}
                          style={{ width: "100%" }}
                          error={
                            this.state.errors.hasOwnProperty("civilStatus")
                              ? this.state.errors.civilStatus !== ""
                              : false
                          }
                        >
                          <InputLabel id="civil-status-select-label">
                            Estado civil
                          </InputLabel>
                          <Select
                            labelId="civil-status-select-label"
                            id="id-simple-select"
                            defaultValue={null}
                            value={this.state.civilStatus}
                            onChange={(event) => {
                              this.handlerCivilStatus(event.target.value);
                            }}
                            error={
                              this.state.errors.hasOwnProperty("civilStatus")
                                ? this.state.errors.civilStatus !== ""
                                : false
                            }
                            disabled={this.state.disabledInput}
                          >
                            <MenuItem key={1} value={"Soltero"}>
                              SOLTERO
                            </MenuItem>
                            <MenuItem key={2} value={"Casado"}>
                              CASADO
                            </MenuItem>
                            <MenuItem key={3} value={"divorciado"}>
                              DIVORCIADO
                            </MenuItem>
                            <MenuItem key={4} value={"Viudo"}>
                              VIUDO
                            </MenuItem>
                            <MenuItem key={5} value={"Unión Libre"}>
                              UNIÓN LIBRE
                            </MenuItem>
                          </Select>
                          <FormHelperText>
                            {this.state.errors.civilStatus}
                          </FormHelperText>
                        </FormControl>
                      </Col>
                      <Col>
                        <FormControl
                          //className={classes.date}
                          style={{ width: "100%" }}
                          error={
                            this.state.errors.hasOwnProperty("race")
                              ? this.state.errors.race !== ""
                              : false
                          }
                        >
                          <InputLabel id="races-status-select-label">
                            Raza
                          </InputLabel>
                          <Select
                            labelId="races-status-select-label"
                            id="id-simple-select"
                            defaultValue={null}
                            value={this.state.race}
                            onChange={(event) => {
                              this.handlerRace(event.target.value);
                            }}
                            error={
                              this.state.errors.hasOwnProperty("race")
                                ? this.state.errors.race !== ""
                                : false
                            }
                            disabled={this.state.disabledInput}
                          >
                            {this.state.races.map((race) => {
                              return (
                                <MenuItem
                                  key={race.id_raza}
                                  value={race.id_raza}
                                >
                                  {race.raza                  }
                                </MenuItem>
                              );
                            })}
                          </Select>
                          <FormHelperText>
                            {this.state.errors.race}
                          </FormHelperText>
                        </FormControl>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={3}>
                    <Row>
                      <Col>
                        <FormControl
                          //className={classes.date}
                          style={{ width: "100%" }}
                          error={
                            this.state.errors.hasOwnProperty("ethnicity")
                              ? this.state.errors.ethnicity !== ""
                              : false
                          }
                        >
                          <InputLabel id="ethnicity-status-select-label">
                            Etnia
                          </InputLabel>
                          <Select
                            labelId="ethnicity-status-select-label"
                            id="id-simple-select"
                            defaultValue={null}
                            value={this.state.ethnicity}
                            onChange={(event) => {
                              this.handlerEthnicity(event.target.value);
                            }}
                            error={
                              this.state.errors.hasOwnProperty("ethnicity")
                                ? this.state.errors.ethnicity !== ""
                                : false
                            }
                            disabled={this.state.disabledInput}
                          >
                            {this.state.ethnicities.map((race) => {
                              return (
                                <MenuItem
                                  key={race.id_etnia}
                                  value={race.id_etnia}
                                >
                                  {race.etnia}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          <FormHelperText>
                            {this.state.errors.ethnicity}
                          </FormHelperText>
                        </FormControl>
                      </Col>
                      <Col>
                        <FormControl
                          //className={classes.date}
                          style={{ width: "100%" }}
                          error={
                            this.state.errors.hasOwnProperty("bloodType")
                              ? this.state.errors.bloodType !== ""
                              : false
                          }
                        >
                          <InputLabel id="blood-type-select-label">
                            Tipo de sangre
                          </InputLabel>
                          <Select
                            labelId="blood-type-select-label"
                            id="id-simple-select"
                            defaultValue={null}
                            value={this.state.bloodType}
                            onChange={(event) => {
                              this.handlerBloodType(event.target.value);
                            }}
                            error={
                              this.state.errors.hasOwnProperty("bloodType")
                                ? this.state.errors.bloodType !== ""
                                : false
                            }
                            disabled={this.state.disabledInput}
                          >
                            <MenuItem key={0} value={"A+"}>
                              A+
                            </MenuItem>
                            <MenuItem key={1} value={"B+"}>
                              B+
                            </MenuItem>
                            <MenuItem key={2} value={"O+"}>
                              O+
                            </MenuItem>
                            <MenuItem key={3} value={"A-"}>
                              A-
                            </MenuItem>
                            <MenuItem key={4} value={"B-"}>
                              B-
                            </MenuItem>
                            <MenuItem key={5} value={"O-"}>
                              O-
                            </MenuItem>
                            <MenuItem key={6} value={"AB+"}>
                              AB+
                            </MenuItem>
                            <MenuItem key={7} value={"AB-"}>
                              AB-
                            </MenuItem>
                            <MenuItem key={8} value={"SIN DEFINIR"}>
                              SIN DEFINIR
                            </MenuItem>
                          </Select>
                          <FormHelperText>
                            {this.state.errors.bloodType}
                          </FormHelperText>
                        </FormControl>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={3}>
                    <FormControl
                      style={{width: "100%"}}
                      error={
                        this.state.errors.hasOwnProperty(
                          "ocupation"
                        )
                          ? this.state.errors.ocupation !== ""
                          : false
                      }
                    >
                      <Autocomplete
                        id="ocupaction-auto-complete"
                        disableCloseOnSelect
                        value={this.state.ocupation}
                        disabled={this.state.disabledInput}
                        options={this.state.occupations}
                        noOptionsText={
                          "No se encontro la Ocupación"
                        }
                        onChange={(e, newValue) => {
                          this.setState({ocupation: newValue});
                        }}
                        getOptionLabel={(occupation) =>
                          occupation.nombre
                        }
                        renderInput={(params) => <TextField {...params} label="Ocupación" variant="standard" />}
                      >
                        
                      </Autocomplete>
                      <FormHelperText>
                        {this.state.errors.ocupation}
                      </FormHelperText>
                    </FormControl>
                  </Col>
                  <Col md={3}>
                    {this.state.listTipos.includes("3") ? (
                      <Fragment>
                        <Row>
                          <Col>
                            <TextField
                              id="peso-standard"
                              label="Peso"
                              placeholder="(kg)"
                              type="number"
                              style={{ width: "100%" }}
                              value={this.state.weight}
                              autoFocus
                              onChange={(event) => {
                                this.setState(
                                  { weight: event.target.value },
                                  () => {
                                    this.getImc();
                                  }
                                );
                              }}
                              error={
                                this.state.errors.hasOwnProperty("weight")
                                  ? this.state.errors.weight !== ""
                                  : false
                              }
                              helperText={this.state.errors.weight}
                              disabled={
                                this.props.dataPatient.dataPatient !== null
                              }
                            />
                          </Col>
                          <Col>
                            <TextField
                              id="talla-standard"
                              label="Talla "
                              placeholder="(20cm)"
                              type="number"
                              style={{ width: "100%" }}
                              value={this.state.height}
                              autoFocus
                              InputProps={{ inputProps: { min: 20, max: 700 } }}
                              onChange={(event) => {
                                this.setState(
                                  { height: event.target.value },
                                  () => {
                                    this.getImc();
                                  }
                                );
                              }}
                              error={
                                this.state.errors.hasOwnProperty("height")
                                  ? this.state.errors.height !== ""
                                  : false
                              }
                              helperText={this.state.errors.height}
                              disabled={
                                this.props.dataPatient.dataPatient !== null
                              }
                            />
                          </Col>
                          <Col>
                            <TextField
                              id="imc"
                              label="IMC"
                              placeholder="IMC"
                              type="text"
                              style={{ width: "100%" }}
                              value={this.state.imc}
                              disabled={true}
                            ></TextField>
                          </Col>
                        </Row>
                      </Fragment>
                    ) : null}
                  </Col>
                </Row>

                <Row style={{ margin: "0em 1em 0em 1em" }}>
                  <Col md={4}>
                    <FormControl 
                    error={
                      this.state.errors.hasOwnProperty("poblacionVulnerable")
                        ? this.state.errors.poblacionVulnerable !== ""
                        : false
                    }
                    style={{ width: "100%" }}>
                      <InputLabel shrink id="poblation-vulnerable-select-label" >Población vulnerable</InputLabel>
                      <Select
                        labelId="poblation-vulnerable-select-label"
                        id="id-simple-select"
                        defaultValue={null}
                        value={this.state.poblacionVulnerable}
                        onChange={(event) => {
                          this.handlePoblacionVulnerable(event.target.value);
                        }}
                        error={
                          this.state.errors.hasOwnProperty("poblacionVulnerable")
                            ? this.state.errors.poblacionVulnerable !== ""
                            : false
                        }
                        disabled={this.state.disabledInput}
                      >
                        {this.state.poblaciones.map((poblacion) => {
                          return (
                            <MenuItem
                              key={poblacion.id_poblacion_vulnerable}
                              value={poblacion.id_poblacion_vulnerable}
                            >
                              {poblacion.nombre}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormHelperText>
                      {this.state.errors.poblacionVulnerable}
                    </FormHelperText>
                  </Col>
                  <Col>
                    <div className="title-add-addmision" style={{display:"flex"}}>
                      <ThemeProvider theme={theme}>
                        <FormControl component="fieldset">
                        <FormLabel component="legend">Discapacidad</FormLabel>
                        <RadioGroup 
                          style={{ flexDirection: "row" }} 
                          value={this.state.disability} 
                          aria-label="disability" 
                          name="disability" 
                          onChange={(event) => {this.handleDisability(event.target.value)}}
                        >
                          <FormControlLabel value="Si" control={<Radio style={{ color: "#4ce1b6" }} />} label="Si" />
                          <FormControlLabel value="No" control={<Radio style={{ color: "#4ce1b6" }}/>} label="No" />
                        </RadioGroup>                   
                        </FormControl>
                      </ThemeProvider>    
                    </div>                                                         
                  </Col>                   
                </Row>
                {this.state.disability === "Si" ? (               
                  <FormDisability 
                    edit_disability={this.state.edit_disability}
                    handleEditDisability={this.handleEditDisability}
                    listDisabilities = {this.state.disabilities}
                    selectedDisability={this.state.selectedDisability}
                    handleSelectDisability={this.handleSelectDisability}
                    updateDisability={this.updateDisability}
                    id_admision={this.state.id_admision}
                  />
                ): null}                                                                               
              </div>
            </React.Fragment>
          ) : null}
          {this.state.showFallingRisks ? (
            this.state.openShowRisk ? (
              <div
                style={{ margin: 10, color: "#4ce1b6", fontSize: 15 }}
                variant="contained"
                color="primary"
                onClick={() => {
                  this.setState({ openShowRisk: false });
                }}
              >
                - Ocultar Riesgo de Caída
              </div>
            ) : (
              <div
                style={{ margin: 10, color: "#4ce1b6", fontSize: 15 }}
                onClick={() => {
                  this.setState({ openShowRisk: true });
                }}
              >
                + Riesgo de Caída
              </div>
            )
          ) : null}
          {this.state.openShowRisk ? (
            <React.Fragment>
              {/* <FormFallingRiskComponent /> */}

              <div
                style={{
                  border: "1px solid #CACDD1",
                  borderRadius: 5,
                  marginTop: 5,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "initial",
                  }}
                >
                  <div style={{ marginLeft: 10, marginTop: 10 }}>
                    <h4>Riesgo de Caída</h4>
                  </div>
                  <div>
                    {this.state.id_admision !== null &&
                    this.state.id_admision !== undefined &&
                    this.state.id_admision !== "" ? (
                      this.state.edit_fallingRisk == false ? (
                        <Tooltip title="Editar Riesgo de Caida">
                          <IconButton
                            aria-label="upload picture"
                            component="span"
                            onClick={() => {
                              this.setState({ edit_fallingRisk: true });
                              this.setState({ disableFormFalling: false });
                            }}
                          >
                            <EditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <>
                          <Tooltip title="Actualizar Datos">
                            <IconButton
                              aria-label="upload picture"
                              component="span"
                              onClick={() => {
                                this.updateFallingRisk();
                              }}
                            >
                              <SaveIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Cancelar Edición">
                            <IconButton
                              aria-label="upload picture"
                              component="span"
                              onClick={() => {
                                //this.setState({ womanInformationEdit: false });
                                this.setState({ edit_fallingRisk: false });
                                this.setState({ disableFormFalling: true });
                              }}
                            >
                              <BlockIcon />
                            </IconButton>
                          </Tooltip>
                        </>
                      )
                    ) : null}
                  </div>
                  <div
                    style={{
                      marginLeft: "auto",
                      marginTop: "0.5em",
                      marginRight: "1em",
                      color: this.state.colorFallingRisk,
                    }}
                  >
                    <h5>Nivel de Riesgo: {this.state.caidas.riesgo}</h5>
                  </div>
                </div>
                <Row>
                  <div className="form" style={{ flexDirection: "column" }}>
                    <div className="half">
                      <div>
                        <Table style={{ height: 70, margin: 0 }}>
                          <tbody>
                            <tr
                              style={{
                                lineHeight: 1,
                                borderTop: "1px solid #6c757d",
                              }}
                            >
                              <td
                                style={{
                                  padding: 9,
                                  fontSize: "1rem",
                                  fontFamily:
                                    "Roboto, Helvetica, Arial, sans-serif",
                                  fontWeight: 400,
                                }}
                              >
                                Caidas previas
                              </td>
                              <td style={{ padding: 2 }}>
                                <FormControl component="fieldset">
                                  <RadioGroup
                                    aria-label="lblCaidasPrev"
                                    name="rdCaidasPrev"
                                    defaultValue={
                                      this.props.dataPatient.caidas !=
                                        undefined &&
                                      this.props.dataPatient.caidas != null
                                        ? this.props.dataPatient.caidas
                                            .caida_previa
                                        : ""
                                    }
                                    value={
                                      this.state.caidas != undefined &&
                                      this.state.caidas != null
                                        ? this.state.caidas.caida_previa
                                        : ""
                                    }
                                    onChange={(e) => {
                                      this.setCaidaCaPr(e.target.value);
                                    }}
                                  >
                                    <FormControlLabel
                                      value="Sí"
                                      control={<Radio color="primary" />}
                                      disabled={this.state.disableFormFalling}
                                      label="Sí"
                                    />
                                    <FormControlLabel
                                      value="No"
                                      control={<Radio color="primary" />}
                                      disabled={this.state.disableFormFalling}
                                      label="No"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </td>
                            </tr>
                            <tr
                              style={{
                                lineHeight: 1,
                                borderTop: "1px solid #6c757d",
                              }}
                            >
                              <td
                                style={{
                                  padding: 9,
                                  fontSize: "1rem",
                                  fontFamily:
                                    "Roboto, Helvetica, Arial, sans-serif",
                                  fontWeight: 400,
                                }}
                              >
                                El Paciente usa medicamentos, Tranquilizantes,
                                sedantes, diuréticos, antidepresivos
                              </td>
                              <td style={{ padding: 2 }}>
                                <FormControl component="fieldset2">
                                  <RadioGroup
                                    aria-label="lblMedicamentos"
                                    name="rdMedicamentos"
                                    defaultValue={
                                      this.props.dataPatient.caidas !=
                                        undefined &&
                                      this.props.dataPatient.caidas != null
                                        ? this.props.dataPatient.caidas
                                            .medicamentos
                                        : ""
                                    }
                                    value={
                                      this.state.caidas != undefined &&
                                      this.state.caidas != null
                                        ? this.state.caidas.medicamentos
                                        : ""
                                    }
                                    onChange={(e) => {
                                      this.setCaida2CaPr(e.target.value);
                                    }}
                                  >
                                    <FormControlLabel
                                      value="Sí"
                                      control={<Radio color="primary" />}
                                      disabled={this.state.disableFormFalling}
                                      label="Sí"
                                    />
                                    <FormControlLabel
                                      value="No"
                                      control={<Radio color="primary" />}
                                      disabled={this.state.disableFormFalling}
                                      label="No"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </td>
                            </tr>
                            <tr
                              style={{
                                lineHeight: 1,
                                borderTop: "1px solid #6c757d",
                              }}
                            >
                              <td
                                style={{
                                  padding: 9,
                                  fontSize: "1rem",
                                  fontFamily:
                                    "Roboto, Helvetica, Arial, sans-serif",
                                  fontWeight: 400,
                                }}
                              >
                                Deficits Sensoriales
                              </td>
                              <td style={{ padding: 2 }}>
                                <FormControl component="fieldset">
                                  <RadioGroup
                                    aria-label="Medicamentos"
                                    name="medicamentos"
                                    defaultValue={
                                      this.props.dataPatient.caidas !=
                                        undefined &&
                                      this.props.dataPatient.caidas != null
                                        ? this.props.dataPatient.caidas
                                            .def_sensoriales
                                        : ""
                                    }
                                    value={
                                      this.state.caidas != undefined &&
                                      this.state.caidas != null
                                        ? this.state.caidas.def_sensoriales
                                        : ""
                                    }
                                    onChange={(e) => {
                                      this.setCaida3CaPr(e.target.value);
                                    }}
                                  >
                                    <FormControlLabel
                                      value="Alteraciones Visuales, Auditivas"
                                      control={<Radio color="primary" />}
                                      disabled={this.state.disableFormFalling}
                                      label="Alteraciones Visuales, Auditivas"
                                    />
                                    <FormControlLabel
                                      value="Ninguno"
                                      control={<Radio color="primary" />}
                                      disabled={this.state.disableFormFalling}
                                      label="Ninguno"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </td>
                            </tr>
                            <tr
                              style={{
                                lineHeight: 1,
                                borderTop: "1px solid #6c757d",
                              }}
                            >
                              <td
                                style={{
                                  padding: 9,
                                  fontSize: "1rem",
                                  fontFamily:
                                    "Roboto, Helvetica, Arial, sans-serif",
                                  fontWeight: 400,
                                }}
                              >
                                Estado mental
                              </td>
                              <td style={{ padding: 2 }}>
                                <FormControl component="fieldset">
                                  <RadioGroup
                                    aria-label="Medicamentos"
                                    name="medicamentos"
                                    defaultValue={
                                      this.props.dataPatient.caidas !=
                                        undefined &&
                                      this.props.dataPatient.caidas != null
                                        ? this.props.dataPatient.caidas
                                            .estado_mental
                                        : ""
                                    }
                                    value={
                                      this.state.caidas != undefined &&
                                      this.state.caidas != null
                                        ? this.state.caidas.estado_mental
                                        : ""
                                    }
                                    onChange={(e) => {
                                      this.setCaida4CaPr(e.target.value);
                                    }}
                                  >
                                    <FormControlLabel
                                      value="Orientado"
                                      control={<Radio color="primary" />}
                                      disabled={this.state.disableFormFalling}
                                      label="Orientado"
                                    />
                                    <FormControlLabel
                                      value="Confuso"
                                      control={<Radio color="primary" />}
                                      disabled={this.state.disableFormFalling}
                                      label="Confuso"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </td>
                            </tr>
                            <tr
                              style={{
                                lineHeight: 1,
                                borderTop: "1px solid #6c757d",
                              }}
                            >
                              <td
                                style={{
                                  padding: 9,
                                  fontSize: "1rem",
                                  fontFamily:
                                    "Roboto, Helvetica, Arial, sans-serif",
                                  fontWeight: 400,
                                }}
                              >
                                El Paciente deambula normalmente de manera
                                segura y sin ayuda
                              </td>
                              <td style={{ padding: 2 }}>
                                <ThemeProvider theme={theme}>
                                  <FormControl component="fieldset">
                                    <RadioGroup
                                      aria-label="Medicamentos"
                                      name="medicamentos"
                                      defaultValue={
                                        this.props.dataPatient.caidas !=
                                          undefined &&
                                        this.props.dataPatient.caidas != null
                                          ? this.props.dataPatient.caidas
                                              .deambulacion
                                          : ""
                                      }
                                      value={
                                        this.state.caidas != undefined &&
                                        this.state.caidas != null
                                          ? this.state.caidas.deambulacion
                                          : ""
                                      }
                                      onChange={(e) => {
                                        this.setCaida5CaPr(e.target.value);
                                      }}
                                    >
                                      <FormControlLabel
                                        value="Sí"
                                        control={<Radio color="primary" />}
                                        disabled={this.state.disableFormFalling}
                                        label="Sí"
                                      />
                                      <FormControlLabel
                                        value="No"
                                        control={<Radio color="primary" />}
                                        disabled={this.state.disableFormFalling}
                                        label="No"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </ThemeProvider>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </Row>
              </div>
            </React.Fragment>
          ) : null}
          {this.state.showSpecialReq ? (
            this.state.openShowReqEsp ? (
              <div
                style={{ margin: 10, color: "#4ce1b6", fontSize: 15 }}
                variant="contained"
                color="primary"
                onClick={() => {
                  this.setState({ openShowReqEsp: false });
                }}
              >
                - Requerimientos Especiales
              </div>
            ) : (
              <div
                style={{ margin: 10, color: "#4ce1b6", fontSize: 15 }}
                onClick={() => {
                  this.setState({ openShowReqEsp: true });
                }}
              >
                + Requerimientos Especiales
              </div>
            )
          ) : null}
          {this.state.openShowReqEsp ? (
            <React.Fragment>
              <FormEspecialReq
                setReqHospitalizado={this.setReqHospitalizado}
                setReqSillas={this.setReqSillas}
                setReqMuletas={this.setReqMuletas}
                setReqSintomas={this.setReqSintomas}
                setReqOxigeno={this.setReqOxigeno}
                setReqCamilla={this.setReqCamilla}
                setReqAmbulancia={this.setReqAmbulancia}
                setReqNinguno={this.setReqNinguno}
                setReqOtro={this.setReqOtro}
                setReqOtroReq={this.setReqOtroReq}
                selectedItems={this.state.requerimientos_especiales}
                disabledForm={this.state.disabledInput}
                disableEspReqForm={this.state.disableEspReqForm}
                setDisableEspReqForm={this.handlerDisableEspReqForm}
                id_admision={this.state.id_admision}
                editReqEsp={this.state.edit_reqEspeciales}
                setEditReqEsp={this.handlerEditReq}
              />
            </React.Fragment>
          ) : null}

          <div
            style={{
              border: "1px solid #CACDD1",
              borderRadius: 5,
              marginTop: 5,
              paddingBottom: "1em",
            }}
          >
            <div style={{ margin: "1em 0em 1em 2em" }}>
              <h4>Datos Cita</h4>
            </div>
            <Row style={{ margin: "0em 1em 0em 1em" }}>
              <Col md={3}>
                <FormControl
                  //className={classes.date}
                  style={{ width: "100%" }}
                  error={
                    this.state.errors.hasOwnProperty("professional")
                      ? this.state.errors.professional !== ""
                      : false
                  }
                >
                  <InputLabel required id="demo-simple-select-label">
                    Profesional
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={this.state.professional}
                    onChange={(event) => {
                      this.handlerProfessional(event.target.value);
                    }}
                    error={
                      this.state.errors.hasOwnProperty("professional")
                        ? this.state.errors.professional !== ""
                        : false
                    }
                    disabled={this.props.dataPatient.dataPatient !== null}
                  >
                    {this.state.professionals.map((professional, index) => {
                      return (
                        <MenuItem
                          key={index}
                          value={professional.id_profesional}
                        >{`${professional.nombres} ${professional.apellido1} ${professional.apellido2}`}</MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText>
                    {this.state.errors.professional}
                  </FormHelperText>
                </FormControl>
              </Col>
              <Col md={3}>
                <FormControl
                  //className={classes.date}
                  style={{ width: "100%" }}
                  error={
                    this.state.errors.hasOwnProperty("workspace")
                      ? this.state.errors.workspace !== ""
                      : false
                  }
                >
                  <InputLabel required id="space-status-select-label">
                    Espacio
                  </InputLabel>
                  <Select
                    labelId="space-select-label"
                    id="id-simple-select"
                    defaultValue={null}
                    value={this.state.workspace}
                    onChange={(event) => {
                      this.handlerWorkspace(event.target.value);
                    }}
                    error={
                      this.state.errors.hasOwnProperty("workspace")
                        ? this.state.errors.workspace !== ""
                        : false
                    }
                    disabled={this.props.dataPatient.dataPatient !== null}
                  >
                    {this.state.workspaces.length > 0
                      ? this.state.workspaces.map((workspace, index) => {
                          return (
                            <MenuItem key={index} value={workspace.id_espacio}>
                              {workspace.espacio}
                            </MenuItem>
                          );
                        })
                      : null}
                  </Select>
                  <FormHelperText>{this.state.errors.workspace}</FormHelperText>
                </FormControl>
              </Col>

              <Col md={3}>
                {!!this.state.workplaces.length && (
                  <TextField
                    select
                    className="medical-material-form__field"
                    style={{ width: "100%", marginLeft: 10 }}
                    InputLabelProps={{
                      style: { color: "#646777" },
                      shrink: true,
                    }}
                    id="workplace-standard"
                    label="Sede"
                    value={this.state.workplaceSelected}
                    onChange={(event) => {
                      this.handlerWorkplace(event.target.value);
                    }}
                    disabled={this.props.dataPatient.dataPatient !== null}
                    InputProps={{
                      classes: {
                        disabled: classes.disabled,
                      },
                    }}
                  >
                    {this.state.workplaces.map((workplace) => (
                      <MenuItem
                        key={workplace.id_sede}
                        value={workplace.id_sede}
                      >
                        {workplace.nombre}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              </Col>
            </Row>
            <Row style={{ margin: "0em 1em 0em 1em" }}>
              <Col md={3}></Col>
            </Row>

            <Row style={{ margin: "0em 1em 0em 1em" }}>
              <Col md={3}>
                <FormControl
                  //className={classes.date}
                  style={{ width: "100%" }}
                  error={
                    this.state.errors.hasOwnProperty("costumer")
                      ? this.state.errors.costumer !== ""
                      : false
                  }
                >
                  <InputLabel
                    required
                    id="demo-simple-select-label"
                    shrink={true}
                  >
                    Cliente
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={this.state.costumer_data}
                    onChange={(event) => {
                      //this.setState({activities: [], pertenece_estudio: false})
                      this.handlerCostumer(event.target.value);
                    }}
                    error={
                      this.state.errors.hasOwnProperty("costumer")
                        ? this.state.errors.costumer !== ""
                        : false
                    }
                    disabled={
                      this.props.dataPatient.dataPatient !== null &&
                      this.state.editRegimenAndServices == false
                    }
                  >
                    <MenuItem value={""}>Ninguno</MenuItem>
                    {this.state.serter.map((service) => {
                      //console.log(service);
                      return (
                        <MenuItem key={service.id_tercero} value={service}>
                          {service.nombre_tercero_concatenado}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText>{this.state.errors.costumer}</FormHelperText>
                </FormControl>
              </Col>
              <Col md={9}>
                {
                  //Esteban Londoño Ospina 24/09/2021
                  //Datos de Cita Normal
                  this.state.pertenece_estudio === false ? (
                    <>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <Col md={3}>
                          <FormControl
                            //className={classes.date}
                            style={{ width: "100%" }}
                            error={
                              this.state.errors.hasOwnProperty("plan")
                                ? this.state.errors.plan !== ""
                                : false
                            }
                          >
                            <InputLabel required id="demo-simple-select-label">
                              Plan
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={this.state.plan}
                              onChange={(event) => {
                                this.handlerPlan(event.target.value);
                                this.loadActivities(
                                  this.state.costumer,
                                  event.target.value,
                                  this.state.professional
                                ).then((activities) => {
                                  this.setState({
                                    activities: activities,
                                    activity: event.target.value,
                                  });
                                });
                              }}
                              error={
                                this.state.errors.hasOwnProperty("plan")
                                  ? this.state.errors.plan !== ""
                                  : false
                              }
                              disabled={
                                this.props.dataPatient.dataPatient !== null &&
                                this.state.editRegimenAndServices == false
                              }
                            >
                              <MenuItem value={{}}>Ninguno</MenuItem>
                              {this.state.plans.map((plan) => {
                                return (
                                  <MenuItem
                                    key={plan.id_plan}
                                    value={plan.id_plan}
                                  >
                                    {plan.nombre}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            <FormHelperText>
                              {this.state.errors.plan}
                            </FormHelperText>
                          </FormControl>
                        </Col>

                        <Col md={7}>
                          <FormControl
                            //style={{ width: 500, position: 'relative', left: 10, marginTop: 14 }}
                            style={{
                              width: "100%",
                              padding: "0em 0em 0em 2em",
                            }}
                            error={
                              this.state.errors.hasOwnProperty(
                                "activitiesAppointment"
                              )
                                ? this.state.errors.activitiesAppointment !== ""
                                : false
                            }
                          >
                            <Autocomplete
                              multiple
                              limitTags={2}
                              id="tags-standard"
                              size="small"
                              disabled={
                                (this.state.activities.length <= 0 ||
                                  this.props.dataPatient.dataPatient !==
                                    null) &&
                                this.state.editRegimenAndServices == false
                                  ? true
                                  : false
                              }
                              options={this.state.activities}
                              disableCloseOnSelect
                              value={this.state.activitiesAppointment}
                              onChange={(event, value, reason, detail) => {
                                console.log(
                                  "AutoCompleteActivity",
                                  event,
                                  value,
                                  reason,
                                  detail
                                );
                                this.handlerActivity(value, detail.option);
                              }}
                              getOptionLabel={(activity) =>
                                activity.codigo + " " + activity.servicios
                              }
                              renderOption={(activity, { selected }) => (
                                <div
                                  className={
                                    this.props.dataPatient.dataPatient !==
                                      null &&
                                    this.state.editRegimenAndServices == false
                                      ? "disabledAutocomplete"
                                      : ""
                                  }
                                  style={{ fontSize: "13px" }}
                                >
                                  <MedicalCheckbox
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  <b>{activity.codigo}</b> {activity.servicios}
                                </div>
                              )}
                              renderTags={(value, getTagProps) =>
                                value.map((activity, index) => (
                                  <Chip
                                    {...getTagProps({ index })}
                                    size="small"
                                    label={
                                      <EllipsisText>
                                        {activity.codigo} - {activity.servicios}
                                      </EllipsisText>
                                    }
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  className="medical-material-form__field"
                                  InputLabelProps={{
                                    style: { color: "#646777" },
                                    shrink: true,
                                  }}
                                  style={{
                                    maxWidth: "80%",
                                    overflow: "hidden",
                                  }}
                                  variant="standard"
                                  label="Actividades a Realizar"
                                  placeholder=""
                                  required={true}
                                />
                              )}
                            />
                            <FormHelperText>
                              {this.state.errors.activitiesAppointment}
                            </FormHelperText>
                          </FormControl>
                        </Col>
                        <Col md={1}>
                          {this.props.dataPatient.dataPatient === null ? (
                            <Tooltip
                              style={
                                this.state.confirmedAdditionalAppointments
                                  .length > 0
                                  ? { color: "#fd7e14" }
                                  : null
                              }
                              title="Agregar mas Servicios con otro Profesional y otras Fechas"
                            >
                              <IconButton
                                aria-label="upload picture"
                                component="span"
                                onClick={() => {
                                  this.setState({
                                    openModalAdditionalAppointment: true,
                                  });
                                }}
                              >
                                <FontAwesomeIcon icon={faPlus} />
                              </IconButton>
                            </Tooltip>
                          ) : null}
                        </Col>

                        <Col md={2}>
                          {this.props.dataPatient.dataPatient != null ||
                          this.props.dataPatient.id_cita != null ||
                          this.props.dataPatient.id_cita != undefined ? (
                            <>
                              {this.state.editRegimenAndServices == false ? (
                                <Tooltip title="Editar datos del Regimen y Servicios">
                                  <IconButton
                                    disabled={
                                      !this.props.dataPatient.recibo_pago ||
                                      (this.props.dataPatient.recibo_pago &&
                                        this.state.estado_facturacion === 1)
                                        ? false
                                        : true
                                    }
                                    aria-label="upload picture"
                                    component="span"
                                    onClick={() => {
                                      this.setState({
                                        editRegimenAndServices: true,
                                      });
                                    }}
                                  >
                                    <EditOutlinedIcon />
                                  </IconButton>
                                </Tooltip>
                              ) : (
                                <>
                                  <Tooltip title="Guardar Cambios">
                                    <IconButton
                                      aria-label="upload picture"
                                      component="span"
                                      onClick={() => {
                                        this.changeRegimenPlanAndServices();
                                      }}
                                    >
                                      <SaveIcon />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Cancelar">
                                    <IconButton
                                      aria-label="upload picture"
                                      component="span"
                                      onClick={() => {
                                        this.setState({
                                          editRegimenAndServices: false,
                                        });
                                      }}
                                    >
                                      <BlockIcon />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}
                            </>
                          ) : null}
                        </Col>
                      </div>
                    </>
                  ) : (
                    <>
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <Col md={6}>
                          <FormControl
                            //className={classes.date}
                            style={{ width: "100%" }}
                            error={
                              this.state.errors.hasOwnProperty(
                                "estudio_clinico"
                              )
                                ? this.state.errors.estudio_clinico !== ""
                                : false
                            }
                          >
                            <InputLabel
                              required
                              id="demo-simple-select-label"
                              shrink={true}
                            >
                              Estudio Clinico
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={this.state.estudio_clinico}
                              onChange={(event) => {
                                //this.setState({activities: [], pertenece_estudio: false})
                                this.handlerChangeClinicalStudio(
                                  event.target.value
                                );
                              }}
                              error={
                                this.state.errors.hasOwnProperty(
                                  "estudio_clinico"
                                )
                                  ? this.state.errors.estudio_clinico !== ""
                                  : false
                              }
                              disabled={
                                this.props.dataPatient.dataPatient !== null
                              }
                            >
                              {this.state.estudios_clinicos.map((estudio) => {
                                return (
                                  <MenuItem
                                    key={estudio.id_estudio}
                                    value={estudio}
                                  >
                                    {estudio.acronimo}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            <FormHelperText>
                              {this.state.errors.estudio_clinico}
                            </FormHelperText>
                          </FormControl>
                        </Col>

                        <Col md={6}>
                          <FormControl
                            //className={classes.date}
                            style={{
                              width: "100%",
                              padding: "0em 0em 0em 2em",
                            }}
                            error={
                              this.state.errors.hasOwnProperty("visita")
                                ? this.state.errors.visita !== ""
                                : false
                            }
                          >
                            <InputLabel
                              required
                              id="demo-simple-select-label"
                              style={{ padding: "0em 0em 0em 2em" }}
                            >
                              Visita
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={this.state.visita}
                              onChange={(event) => {
                                this.handlerChangeVisits(event.target.value);
                              }}
                              error={
                                this.state.errors.hasOwnProperty("visita")
                                  ? this.state.errors.visita !== ""
                                  : false
                              }
                              disabled={
                                this.props.dataPatient.dataPatient !== null
                              }
                            >
                              {this.state.visitas.map((visita) => {
                                return (
                                  <MenuItem
                                    key={visita.id_visita}
                                    value={visita}
                                  >
                                    {visita.nombre}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                            <FormHelperText>
                              {this.state.errors.visita}
                            </FormHelperText>
                          </FormControl>
                        </Col>
                      </div>
                    </>
                  )
                }
              </Col>
            </Row>
          </div>
          <div
            style={{
              border: "1px solid #CACDD1",
              borderRadius: 5,
              marginTop: 5,
              paddingBottom: "1em",
            }}
          >
            <div
              className="title-add-addmision"
              style={{ margin: "1em 0em 1em 2em" }}
            >
              <div>
                <h4>Datos de la Admisión</h4>
              </div>
              <div>
                {
                  /*  this.props.dataPatient.dataPatient !== null || (this.props.dataPatient.id_cita !== null || this.props.dataPatient.id_cita !== undefined || this.state.disabled) */
                  this.state.id_admision !== "" ? (
                    <>
                      {this.state.editInfoAdmission == false ? (
                        <Tooltip title="Editar datos de la Admisión">
                          <IconButton
                            aria-label="upload picture"
                            component="span"
                            onClick={() => {
                              /*
                                            if(profile === '9' || profile === '11' || profile === '19' || profile == '26'){
                                              this.setState({ editInfoAdmission: true });
                                              console.log(profile);
                                            } else {
                                              console.log(profile);
                                              alert("No tienes permiso para hacer esto")
                                            }
                              */
                              this.setState({ editInfoAdmission: true });
                              console.log(profile);
                            }}
                          >
                            <EditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <>
                          <Tooltip title="Guardar Cambios">
                            <IconButton
                              aria-label="upload picture"
                              component="span"
                              onClick={() => {
                                //this.changeRegimenPlanAndServices();
                                this.changeInfoAdmission();
                              }}
                            >
                              <SaveIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Cancelar">
                            <IconButton
                              aria-label="upload picture"
                              component="span"
                              onClick={() => {
                                this.setState({ editInfoAdmission: false });
                              }}
                            >
                              <BlockIcon />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                    </>
                  ) : null
                }
              </div>
            </div>
            <Row style={{ margin: "0em 1em 0em 1em" }}>
              <Col md={3}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <KeyboardDateTimePicker
                    required
                    value={this.state.date}
                    onChange={this.handlerDate}
                    label="Fecha y hora de admisión"
                    onError={console.log}
                    minDate={new Date("2020-01-01T00:00")}
                    format="yyyy/MM/DD hh:mm a"
                    //className={classes.date}
                    style={{ width: "100%" }}
                    //disabled={this.props.dataPatient.dataPatient !== null && this.state.editInfoAdmission }
                    disabled
                    /* disabled={
                                      (this.props.dataPatient.id_cita != null &&
                                          this.props.dataPatient.id_cita != undefined &&
                                          this.props.dataPatient.id_cita != 'undefined') || (this.state.disabled && this.state.editInfoAdmission == false)
                                          ? true : false
                                  } */
                  />
                </MuiPickersUtilsProvider>
              </Col>
              <Col md={3}>
                <TextField
                  //className={classes.date}
                  style={{ width: "100%" }}
                  id="auth-standard-required"
                  label="No. de Autorizacion"
                  type="text"
                  value={this.state.authorization}
                  onChange={(e) => {
                    this.handlerAuthorization(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true,
                    style: { color: "#646777" },
                  }}
                  disabled={
                    this.state.disabled && this.state.editInfoAdmission == false
                  }
                  error={
                    this.state.errors.hasOwnProperty("authorization")
                      ? this.state.errors.authorization !== ""
                      : false
                  }
                  helperText={this.state.errors.authorization}
                />
              </Col>

              {/* Codigo de Validacion */}
              <Col md={3}>
                <TextField
                  //className={classes.date}
                  style={{ width: "100%" }}
                  id="auth-standard-required"
                  label="Codigo de Validación"
                  type="text"
                  value={this.state.validationCode}
                  onChange={(e) => {
                    this.handlerValidationCode(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true,
                    style: { color: "#646777" },
                  }}
                  disabled={
                    this.state.disabled && this.state.editInfoAdmission == false
                  }
                  error={
                    this.state.errors.hasOwnProperty("validationCode")
                      ? this.state.errors.validationCode !== ""
                      : false
                  }
                  helperText={this.state.errors.validationCode}
                />
              </Col>
              <Col md={3}>
                <FormControl
                  style={{ width: "100%" }}
                  error={
                    this.state.errors.hasOwnProperty("typeOfUser")
                      ? this.state.errors.typeOfUser !== ""
                      : false
                  }
                >
                  <InputLabel required id="typeOfUser-status-select-label">
                    Tipo de Usuario
                  </InputLabel>
                  <Select
                    labelId="typeOfUser-select-label"
                    id="typeOfUser-simple-select"
                    value={this.state.typeOfUser}
                    disabled={
                      this.state.disabled &&
                      this.state.editInfoAdmission == false
                    }
                    onChange={(event) => {
                      this.handlerTypeOfUser(event.target.value);
                    }}
                    error={
                      this.state.errors.hasOwnProperty("typeOfUser")
                        ? this.state.errors.typeOfUser !== ""
                        : false
                    }
                  >
                    {this.state.tiposUsuario.map(
                      (tipoUsuario) =>
                        tipoUsuario.estado && (
                          // En el futuro cambiar el tipo de usuario por el codigo
                          <MenuItem
                            key={tipoUsuario.id_tipo_salud}
                            value={tipoUsuario.id_tipo_salud}
                          >
                            {tipoUsuario.nombre}
                          </MenuItem>
                        )
                    )}

                    {/* <MenuItem key={1} value={"01"}>
                      AFILIADO AL RÉGIMEN SUBSIDIADO
                    </MenuItem>
                    <MenuItem key={2} value={"02"}>
                      COTIZANTE
                    </MenuItem>
                    <MenuItem key={2} value={"03"}>
                      BENEFICIARIO
                    </MenuItem>
                    <MenuItem key={3} value={"04"}>
                      ADICIONAL
                    </MenuItem>
                    <MenuItem key={2} value={"05"}>
                      RÉGIMEN ESPECIALES O DE EXCEPCIÓN
                    </MenuItem>
                    <MenuItem key={2} value={"06"}>
                      TOMADOR/AMPARADO
                    </MenuItem>
                    <MenuItem key={2} value={"07"}>
                      SIN RÉGIMEN
                    </MenuItem> */}
                  </Select>
                  <FormHelperText>
                    {this.state.errors.typeOfUser}
                  </FormHelperText>
                </FormControl>
              </Col>
            </Row>
            <Row style={{ margin: "0em 1em 0em 1em" }}>
              {this.state.regime === 2 || this.state.regime === 3 ? (
                this.state.regime === 3 ? (
                  <Col md={3}>
                    <FormControl
                      //className={classes.date}
                      style={{ width: "100%" }}
                      error={
                        this.state.errors.hasOwnProperty("rangeLevelRegime")
                          ? this.state.errors.rangeLevelRegime !== ""
                          : false
                      }
                    >
                      <InputLabel id="rangeLevelRegime-status-select-label">
                        Rango o Nivel
                      </InputLabel>
                      <Select
                        labelId="rangeLevelRegime-select-label"
                        id="rangeLevelRegime-simple-select"
                        value={this.state.rangeLevelRegime}
                        disabled={
                          this.state.disabled &&
                          this.state.editInfoAdmission == false
                        }
                        onChange={(event) => {
                          this.handlerRangeLevelRegime(event.target.value);
                        }}
                        error={
                          this.state.errors.hasOwnProperty("rangeLevelRegime")
                            ? this.state.errors.rangeLevelRegime !== ""
                            : false
                        }
                      >
                        <MenuItem key={1} value={"A"}>
                          A
                        </MenuItem>
                        <MenuItem key={2} value={"B"}>
                          B
                        </MenuItem>
                        <MenuItem key={3} value={"C"}>
                          C
                        </MenuItem>
                      </Select>
                      <FormHelperText>
                        {this.state.errors.rangeLevelRegime}
                      </FormHelperText>
                    </FormControl>
                  </Col>
                ) : (
                  <Col md={3}>
                    <FormControl
                      //className={classes.date}
                      style={{ width: "100%" }}
                      error={
                        this.state.errors.hasOwnProperty("rangeLevelRegime")
                          ? this.state.errors.rangeLevelRegime !== ""
                          : false
                      }
                    >
                      <InputLabel id="rangeLevelRegime-status-select-label">
                        Rango o Nivel
                      </InputLabel>
                      <Select
                        labelId="rangeLevelRegime-select-label"
                        id="rangeLevelRegime-simple-select"
                        value={this.state.rangeLevelRegime}
                        disabled={
                          this.state.disabled &&
                          this.state.editInfoAdmission == false
                        }
                        onChange={(event) => {
                          this.handlerRangeLevelRegime(event.target.value);
                        }}
                        error={
                          this.state.errors.hasOwnProperty("rangeLevelRegime")
                            ? this.state.errors.rangeLevelRegime !== ""
                            : false
                        }
                      >
                        <MenuItem key={5} value={"I"}>
                          I
                        </MenuItem>
                        <MenuItem key={6} value={"II"}>
                          II
                        </MenuItem>
                      </Select>
                      <FormHelperText>
                        {this.state.errors.rangeLevelRegime}
                      </FormHelperText>
                    </FormControl>
                  </Col>
                )
              ) : null}
              {this.state.listTipos.includes("4") ? (
                <Col md={3}>
                  <div className="answer-background flex-spac-ar-elem">
                    <div
                      style={{
                        width: "95%",
                        marginRight: "1.25em",
                        marginTop: "0.8em",
                      }}
                    >
                      <FormControl
                        style={{ width: "100%" }}
                        /* error={errors.hasOwnProperty("patientAlergies") ? errors.patientAlergies !== "" : false} */
                      >
                        <Autocomplete
                          multiple
                          id="tags-standard"
                          style={{ width: "100%" }}
                          options={this.state.listReferringDoctors}
                          value={this.state.referringDoctors}
                          getOptionLabel={(option) => option.nombre}
                          disabled={
                            this.state.disabled &&
                            this.state.editInfoAdmission == false
                          }
                          onChange={(event, value, reason, detail) => {
                            console.log(
                              "evento",
                              event,
                              "valor",
                              value,
                              "reason",
                              reason,
                              "detail",
                              detail
                            );
                            this.handlerAddRefferingDocToString(
                              detail.option,
                              reason
                            );
                            this.handlerPushReffereingDoc(
                              detail.option,
                              reason
                            );
                          }}
                          renderInput={(params) => {
                            console.log("WhatParams", params);
                            return (
                              <TextField
                                {...params}
                                variant="standard"
                                label=""
                                placeholder="Medicos Remitentes"
                                className="text-field-autocomplete"
                              />
                            );
                          }}
                          error={
                            this.state.errors.hasOwnProperty("medico_remitente")
                              ? this.state.errors.medico_remitente !== ""
                              : false
                          }
                          helperText={this.state.errors.medico_remitente}
                        />
                      </FormControl>
                    </div>
                    <div style={{ width: "95%", marginLeft: "0.25em" }}>
                      <TextField
                        label="Otro?"
                        disabled={
                          this.state.disabled &&
                          this.state.editInfoAdmission == false
                        }
                        value={this.state.docRemAdd}
                        onChange={(e) => {
                          this.setState({
                            docRemAdd: e.target.value.toString().toUpperCase(),
                          });
                        }}
                        style={{ minWidth: "100%", maxWidth: "100%" }}
                        className="medical-material-form__field"
                        InputLabelProps={
                          {
                            //style: { color: '#646777' }
                          }
                        }
                      />
                    </div>
                    <div>
                      <Tooltip
                        title="Agregar"
                        disabled={
                          (this.state.disabled &&
                            this.state.editInfoAdmission == false) ||
                          !this.state.docRemAdd
                        }
                      >
                        <IconButton
                          color="primary"
                          onClick={() => {
                            this.handlerSendRefferingDoctor();
                          }}
                        >
                          <span
                            className="lnr lnr-plus-circle"
                            style={{ margin: "auto", fontSize: 20 }}
                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                </Col>
              ) : (
                <Col md={3}>
                  <TextField
                    required
                    style={{ width: "100%" }}
                    id="Remitente-standard"
                    label="Nombre Completo del Remitente"
                    type="text"
                    value={this.state.medico_remitente}
                    onChange={(e) => {
                      //this.handlerDocumentNumberCompanion(0, e.target.value);
                      this.handlerMedicoRemitente(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true,
                      style: { color: "#646777" },
                    }}
                    disabled={
                      this.state.disabled &&
                      this.state.editInfoAdmission == false
                    }
                    error={
                      this.state.errors.hasOwnProperty("medico_remitente")
                        ? this.state.errors.medico_remitente !== ""
                        : false
                    }
                    helperText={this.state.errors.medico_remitente}
                  />
                </Col>
              )}
              <Col md={3}>
                <FormControl
                  //className={classes.date}
                  style={{ width: "100%" }}
                >
                  <InputLabel required id="demo-simple-select-label">
                    Finalidad de la Cita
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="id-simple-select"
                    value={
                      this.state.typeConsult !== null
                        ? this.state.typeConsult
                        : ""
                    }
                    onChange={(event) => {
                      this.setState({ typeConsult: event.target.value });
                    }}
                    disabled={
                      this.state.disabled &&
                      this.state.editInfoAdmission == false
                    }
                    /* disabled={
                                      (this.props.dataPatient.id_cita != null &&
                                          this.props.dataPatient.id_cita != undefined &&
                                          this.props.dataPatient.id_cita != 'undefined') || (this.state.disabled && this.state.editInfoAdmission == false)
                                          ? true : false
                                  } */
                  >
                    {this.state.tiposConsulta.map(
                      (tipoConsulta) =>
                        // En el futuro cambiar el tipo de usuario por el codigo
                        tipoConsulta.estado === "A" && (
                          <MenuItem
                            key={tipoConsulta.id_tipo_consulta}
                            value={tipoConsulta.id_tipo_consulta}
                          >
                            {tipoConsulta.nombre}
                          </MenuItem>
                        )
                    )}
                    {/* <MenuItem key={1} value={"01"}>
                      ATENCION DEL PARTO (PUERPERIO)
                    </MenuItem>
                    <MenuItem key={2} value={"02"}>
                      ATENCION DEL RECIEN NACIDO
                    </MenuItem>
                    <MenuItem key={3} value={"03"}>
                      ATENCION EN PLANIFICACION FAMILIAR
                    </MenuItem>
                    <MenuItem key={4} value={"04"}>
                      DETECCION DE ALTERACIONES DE CRECIMIENTO Y DESARROLLO DEL
                      MENOR DE DIEZ AÑOS
                    </MenuItem>
                    <MenuItem key={5} value={"05"}>
                      DETECCION DE ALTERACION DEL DESARROLLO JOVEN
                    </MenuItem>
                    <MenuItem key={6} value={"06"}>
                      DETECCION DE ALTERACIONES DEL EMBARAZO
                    </MenuItem>
                    <MenuItem key={7} value={"07"}>
                      DETECCION DE ALTERACIONES DEL ADULTO
                    </MenuItem>
                    <MenuItem key={8} value={"08"}>
                      DETECCION DE ALTERACIONES DE AGUDEZA VISUAL
                    </MenuItem>
                    <MenuItem key={9} value={"09"}>
                      DETECCION DE ENFERMEDAD PROFESIONAL
                    </MenuItem>
                    <MenuItem key={10} value={"10"}>
                      NO APLICA
                    </MenuItem> */}
                  </Select>
                </FormControl>
              </Col>
              <Col md={3}>
                <FormControl
                  //className={classes.date}
                  style={{ width: "100%" }}
                >
                  <InputLabel required id="demo-simple-select-label">
                    Causa Externa
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="id-simple-select"
                    defaultValue={"13"}
                    value={this.state.externalCause}
                    onChange={(event) => {
                      this.setState({ externalCause: event.target.value });
                    }}
                    disabled={
                      this.state.disabled &&
                      this.state.editInfoAdmission == false
                    }
                  >
                    {this.state.causasMotivoAtencion.map(
                      (causaMotivoAtencion) =>
                        causaMotivoAtencion.estado === "A" && (
                          <MenuItem
                            key={causaMotivoAtencion.id_causa_motivo_atencion}
                            value={causaMotivoAtencion.id_causa_motivo_atencion}
                          >
                            {causaMotivoAtencion.nombre.toUpperCase()}
                          </MenuItem>
                        )
                    )}

                    {/* <MenuItem key={1} value={1}>
                      ACCIDENTE DE TRABAJO
                    </MenuItem>
                    <MenuItem key={2} value={2}>
                      ACCIDENTE DE TRÁNSITO
                    </MenuItem>
                    <MenuItem key={3} value={3}>
                      ACCIDENTE RÁBICO
                    </MenuItem>
                    <MenuItem key={4} value={4}>
                      ACCIDENTE OFÍDICO
                    </MenuItem>
                    <MenuItem key={5} value={5}>
                      OTRO TIPO DE ACCIDENTE
                    </MenuItem>
                    <MenuItem key={6} value={6}>
                      EVENTO CATASTRÓFICO
                    </MenuItem>
                    <MenuItem key={7} value={7}>
                      LESIÓN POR AGRESIÓN
                    </MenuItem>
                    <MenuItem key={8} value={8}>
                      LESIÓN AUTO INFLIGIDA
                    </MenuItem>
                    <MenuItem key={9} value={9}>
                      SOSPECHA DE MALTRATO FÍSICO
                    </MenuItem>
                    <MenuItem key={10} value={10}>
                      SOSPECHA DE ABUSO SEXUAL
                    </MenuItem>
                    <MenuItem key={11} value={11}>
                      SOSPECHA DE VIOLENCIA SEXUAL
                    </MenuItem>
                    <MenuItem key={12} value={12}>
                      SOSPECHA DE MALTRATO EMOCIONAL
                    </MenuItem>
                    <MenuItem key={13} value={13}>
                      ENFERMEDAD GENERAL
                    </MenuItem>
                    <MenuItem key={14} value={14}>
                      ENFERMEDAD LABORAL
                    </MenuItem>
                    <MenuItem key={15} value={15}>
                      OTRA
                    </MenuItem> */}
                  </Select>
                </FormControl>
              </Col>
              <Col md={3}>
                <FormControl
                  //className={classes.date}
                  style={{ width: "100%" }}
                >
                  <InputLabel required id="demo-simple-select-label">
                    Via de Ingreso
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="id-simple-select"
                    defaultValue={"13"}
                    value={this.state.viaIngreso}
                    onChange={(event) => {
                      this.setState({ viaIngreso: event.target.value });
                    }}
                    disabled={
                      this.state.disabled &&
                      this.state.editInfoAdmission == false
                    }
                  >
                    {this.state.viasIngresoSalud.map(
                      (viaIngresoSalud) =>
                        viaIngresoSalud.estado === "A" && (
                          <MenuItem
                            key={viaIngresoSalud.id_via_ingreso_salud}
                            value={viaIngresoSalud.id_via_ingreso_salud}
                          >
                            {viaIngresoSalud.nombre}
                          </MenuItem>
                        )
                    )}
                  </Select>
                </FormControl>
              </Col>
            </Row>
          </div>
          {this.state.numHabitacion && (
            <div
              style={{
                border: "1px solid #CACDD1",
                borderRadius: 5,
                marginTop: 5,
                paddingBottom: "1em",
              }}
            >
              <div
                style={{
                  margin: "1em 0em 1em 2em",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{ margin: "1em 0em 0em 0em" }}>
                  <h4>Datos de aislamiento</h4>
                </div>

                <div>
                  {this.state.id_admision !== "" ? (
                    <>
                      {this.state.editInfoAislamiento == false ? (
                        <Tooltip title="Editar datos del Aislamiento">
                          <IconButton
                            aria-label="upload picture"
                            component="span"
                            onClick={() => {
                              this.setState({ editInfoAislamiento: true });
                            }}
                          >
                            <EditOutlinedIcon />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <>
                          <Tooltip title="Guardar Cambios">
                            <IconButton
                              aria-label="upload picture"
                              component="span"
                              onClick={() => {
                                this.changeInfoAislamiento();
                              }}
                            >
                              <SaveIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Cancelar">
                            <IconButton
                              aria-label="upload picture"
                              component="span"
                              onClick={() => {
                                this.setState({ editInfoAislamiento: false });
                              }}
                            >
                              <BlockIcon />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}
                    </>
                  ) : null}
                </div>
              </div>
              <Row style={{ margin: "0em 1em 0em 1em" }}>
                <Col md={3}>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardDateTimePicker
                      required
                      disableFuture={true}
                      value={this.state.fechaIngreso}
                      onChange={this.handleDateEntry}
                      label="Fecha y hora de ingreso"
                      onError={console.log}
                      format="yyyy/MM/DD hh:mm a"
                      minDate={
                        new Date(
                          moment(this.state.fecha).format("YYYY-MM-DD HH:mm:ss")
                        )
                      }
                      style={{ width: "100%" }}
                      disabled={
                        this.state.disabled &&
                        this.state.editInfoAislamiento == false
                      }
                    />
                  </MuiPickersUtilsProvider>
                </Col>
                <Col md={3}>
                  <TextField
                    style={{ width: "100%" }}
                    id="num-habitacion-standard-required"
                    label="Número de la habitación"
                    type="text"
                    value={this.state.numHabitacion}
                    disabled
                    onChange={(e) => {
                      this.handleRoomNumber(e.target.value);
                    }}
                    helperText={this.state.errors.numHabitacion}
                  />
                </Col>
                <Col md={3}>
                  <TextField
                    required
                    style={{ width: "100%" }}
                    id="descripcion-standard-required"
                    label="Descripción"
                    type="text"
                    disabled
                    value={this.state.descripcionHabitacion}
                    onChange={(e) => {
                      this.handleRoomDescription(e.target.value);
                    }}
                    error={
                      this.state.errors.hasOwnProperty("descripcionHabitacion")
                        ? this.state.errors.descripcionHabitacion !== ""
                        : false
                    }
                    helperText={this.state.errors.descripcionHabitacion}
                  />
                </Col>
                <Col md={3}>
                  <FormControl
                    style={{ width: "100%" }}
                    error={
                      this.state.errors.hasOwnProperty("dietaPaciente")
                        ? this.state.errors.dietaPaciente !== ""
                        : false
                    }
                  >
                    <InputLabel id="dietaPaciente-status-select-labe">
                      Dietas del paciente
                    </InputLabel>
                    <Select
                      labelId="dietaPaciente-simple-select-label"
                      id="dietaPaciente-simple-select"
                      value={this.state.dietaPaciente}
                      onChange={this.handleDietsPacient}
                      fullWidth
                      error={
                        this.state.errors.hasOwnProperty("dietaPaciente")
                          ? this.state.errors.dietaPaciente !== ""
                          : false
                      }
                      disabled={
                        this.state.disabled &&
                        this.state.editInfoAislamiento == false
                      }
                    >
                      {this.state.dietasPacientes.map((dieta) => (
                        <MenuItem
                          className="material-form__option"
                          key={dieta.id_dietas_pacientes}
                          value={dieta.id_dietas_pacientes}
                        >
                          {dieta.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>
                      {this.state.errors.dietaPaciente}
                    </FormHelperText>
                  </FormControl>
                </Col>
                {this.state.id_admision != "" && (
                  <>
                    <Col md={3}>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDateTimePicker
                          required
                          disablePast={true}
                          disableFuture={true}
                          value={this.state.fechaEgreso}
                          onChange={this.handleDateEgress}
                          label="Fecha y hora de egreso"
                          onError={console.log}
                          minDate={new Date("2020-01-01T00:00")}
                          format="yyyy/MM/DD hh:mm a"
                          style={{ width: "100%" }}
                          disabled={
                            this.state.disabled &&
                            this.state.editInfoAislamiento == false
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </Col>

                    <Col
                      md={4}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        columnGap: "4px",
                      }}
                    >
                      <Tooltip title="Buscar diagnostico">
                        <IconButton
                          aria-label="upload picture"
                          component="span"
                          color="primary"
                          onClick={() => {
                            this.setState({
                              openModalDiagnostico:
                                !this.state.openModalDiagnostico,
                            });
                          }}
                          disabled={
                            this.state.disabled &&
                            this.state.editInfoAislamiento == false
                          }
                        >
                          <span
                            className="lnr lnr-magnifier"
                            style={{ fontSize: 20, color: "#153365" }}
                          />
                        </IconButton>
                      </Tooltip>
                      <TextField
                        required
                        InputLabelProps={{
                          shrink: !!(
                            this.state.diagnosticAislamiento?.codigo ||
                            this.state.diagnosticAislamiento?.nombre
                          ),
                        }}
                        style={{ width: "100%" }}
                        id="descripcion-diagn-standard-required"
                        label="Diagnostico egreso"
                        type="text"
                        disabled
                        value={
                          (this.state.diagnosticAislamiento?.codigo || "") +
                          (this.state.diagnosticAislamiento?.codigo
                            ? " - "
                            : "") +
                          (this.state.diagnosticAislamiento?.nombre || "")
                        }
                        error={
                          this.state.errors.hasOwnProperty(
                            "diagnosticAislamiento"
                          )
                            ? this.state.errors.diagnosticAislamiento !== ""
                            : false
                        }
                        helperText={this.state.errors.diagnosticAislamiento}
                      />
                    </Col>
                  </>
                )}
              </Row>
            </div>
          )}

          <div
            style={{
              border: "1px solid #CACDD1",
              borderRadius: 5,
              marginTop: 5,
            }}
          >
            <div style={{ margin: "1em 0em 1em 2em" }}>
              <h4>Datos del Representante Legal</h4>
            </div>
            <Row style={{ margin: "0em 1em 0em 1em" }}>
              {this.state.represent.map((repre, index) => {
                return (
                  <Row>
                    <FormRepresent
                      index={index}
                      dataCompanion={repre}
                      enable={
                        this.state.disabled == true &&
                        this.state.editLegalRepresent == false
                          ? true
                          : false
                      }
                      errors={
                        this.state.errors.hasOwnProperty("companions")
                          ? this.state.errors.represent
                          : null
                      }
                      handlerDocumentNumber={
                        this.handlerDocumentNumberRepresent
                      }
                      handlerTypeCompanion={this.handlerTypeRepresent}
                      handlerName={this.handlerNameRepresent}
                      handlerFirstTelephone={
                        this.handlerFirstTelephoneRepresent
                      }
                      handlerSecondTelephone={
                        this.handlerSecondTelephoneRepresent
                      }
                      handlerRelationship={this.handlerRelationshipRepresent}
                    />
                    {index === 0 && !!this.props.dataPatient.id_admision ? (
                      <Col md={2}>
                        {this.state.editLegalRepresent == false ? (
                          <Tooltip title="Editar datos del Representante Legal">
                            <IconButton
                              aria-label="upload picture"
                              component="span"
                              onClick={() => {
                                this.setState({
                                  editLegalRepresent: true,
                                });
                              }}
                            >
                              <EditOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <>
                            <Tooltip title="Guardar Cambios">
                              <IconButton
                                aria-label="upload picture"
                                component="span"
                                onClick={() => {
                                  this.changeCompanionsLegalRepresent();
                                }}
                              >
                                <SaveIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Cancelar">
                              <IconButton
                                aria-label="upload picture"
                                component="span"
                                onClick={() => {
                                  this.setState({
                                    editLegalRepresent: false,
                                  });
                                }}
                              >
                                <BlockIcon />
                              </IconButton>
                            </Tooltip>
                          </>
                        )}
                      </Col>
                    ) : null}
                  </Row>
                );
              })}
            </Row>
            <Row style={{ margin: "0em 1em 0em 1em" }}>
              {!this.state.disabled ? (
                <div>
                  <Button
                    color="primary"
                    onClick={() => {
                      if (this.state.represent.length < 2) {
                        var errors = this.state.errors;
                        errors.represent.push({
                          number: "",
                          name: "",
                          firstTelephone: "",
                          secondTelephone: "",
                          typeCompanion: "",
                          relationship: "",
                        });

                        this.setState({
                          represent: [
                            ...this.state.represent,
                            {
                              number: "",
                              name: "",
                              firstTelephone: "",
                              secondTelephone: "",
                              relationship: "",
                              typeCompanion: [],
                            },
                          ],
                          errors: errors,
                        });
                      }
                    }}
                    disabled={this.state.represent.length > 1}
                    style={{ margin: 10 }}
                  >
                    +
                  </Button>
                  <Button
                    color="primary"
                    onClick={() => {
                      var represent = this.state.represent;
                      represent.pop();
                      var errors = this.state.errors;
                      errors.represent.pop();
                      this.setState({ represent: represent, errors: errors });
                    }}
                    disabled={this.state.represent.length === 1}
                    style={{ margin: 10 }}
                  >
                    -
                  </Button>
                </div>
              ) : null}
            </Row>
          </div>
          <div
            style={{
              border: "1px solid #CACDD1",
              borderRadius: 5,
              marginTop: 5,
              paddingBottom: "1em",
            }}
          >                               
            <div style={{ margin: "1em 0em 1em 2em" }}>
              <div className="title-add-addmision">
                <ThemeProvider theme={theme}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Con acompañante </FormLabel>
                    <RadioGroup
                      defaultValue="No"
                      aria-label="acompañante"
                      name="customized-radios"
                      style={{ flexDirection: "row" }}
                      value={this.state.companion}
                      onChange={(event) => {
                        this.handlerCompanion(event.target.value);

                        let errors = this.state.errors;
                        errors.companions.push({
                          number: "",
                          name: "",
                          firstTelephone: "",
                          secondTelephone: "",
                          typeCompanion: "",
                          relationship: "",
                        });

                        this.setState({ errors: errors });
                      }}
                    >
                      <FormControlLabel
                        disabled={this.state.disabled == true && this.state.editCompanion == false ? true : false}
                        value="Si"
                        control={<Radio style={{ color: "#4ce1b6" }} />}
                        label="Si"
                      />
                      <FormControlLabel
                        disabled={this.state.disabled == true && this.state.editCompanion == false ? true : false}
                        value="No"
                        control={<Radio style={{ color: "#4ce1b6" }} />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </ThemeProvider>
                {!!this.props.dataPatient.id_admision &&
                  <div style={{display:"flex",}}>
                    {this.state.editCompanion == false ? (
                      <Tooltip title="Editar datos del Acompañante">
                        <IconButton
                          aria-label="upload picture"
                          component="span"
                          onClick={() => {
                            this.setState({
                              editCompanion: true,
                            });
                          }}
                        >
                          <EditOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Guardar Cambios">
                          <IconButton
                            aria-label="upload picture"
                            component="span"
                            style={{display:"inherit"

                            }}
                            onClick={() => {
                              this.changeCompanionsLegalRepresent();
                            }}
                          >
                            <SaveIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Cancelar">
                          <IconButton
                            aria-label="upload picture"
                            component="span"
                            onClick={() => {
                              this.setState({
                                editCompanion: false,
                              });
                            }}
                          >
                            <BlockIcon />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </div>
                }
              </div>
              {this.state.companion === "Si" ? (
                <React.Fragment>
                  <div style={{ margin: 10 }}>
                    <h4>Datos del Acompañante</h4>
                  </div>
                  {this.state.companions.map((companion, index) => {
                    return (
                      <FormCompanions
                        index={index}
                        dataCompanion={companion}
                        disabled={
                          this.props.dataPatient.hasOwnProperty(
                            "id_admision"
                          ) &&
                          this.state.disabled == true &&
                          this.state.editCompanion == false
                            ? true
                            : false
                        }
                        errors={
                          this.state.errors.hasOwnProperty("companions")
                            ? this.state.errors.companions
                            : null
                        }
                        handlerDocumentNumber={
                          this.handlerDocumentNumberCompanion
                        }
                        handlerTypeCompanion={this.handlerTypeCompanion}
                        handlerName={this.handlerNameCompanion}
                        handlerFirstTelephone={
                          this.handlerFirstTelephoneCompanion
                        }
                        handlerSecondTelephone={
                          this.handlerSecondTelephoneCompanion
                        }
                        handlerRelationship={this.handlerRelationshipCompanion}
                      />
                    );
                  })}
                  <div>
                    <Button
                      color="primary"
                      onClick={() => {
                        if (this.state.companions.length <= 2) {
                          var errors = this.state.errors;
                          errors.companions.push({
                            number: "",
                            name: "",
                            firstTelephone: "",
                            secondTelephone: "",
                            typeCompanion: "",
                            relationship: "",
                          });

                          this.setState({
                            companions: [
                              ...this.state.companions,
                              {
                                number: "",
                                name: "",
                                firstTelephone: "",
                                secondTelephone: "",
                                relationship: "",
                                typeCompanion: [],
                              },
                            ],
                            errors: errors,
                          });
                        }
                      }}
                      disabled={
                        this.state.companions.length > 2 ||
                        (this.props.dataPatient.hasOwnProperty("id_admision") &&
                          this.state.editCompanion == false)
                      }
                      style={{ margin: 10 }}
                    >
                      +
                    </Button>
                    <Button
                      color="primary"
                      onClick={() => {
                        var companions = this.state.companions;
                        companions.pop();
                        var errors = this.state.errors;
                        errors.companions.pop();
                        this.setState({
                          companions: companions,
                          errors: errors,
                        });
                      }}
                      disabled={
                        this.state.companions.length === 1 ||
                         (this.props.dataPatient.hasOwnProperty("id_admision") &&
                          this.state.editCompanion == false) 
                      }
                      style={{ margin: 10 }}
                    >
                      -
                    </Button>
                  </div>
                </React.Fragment>
              ) : null}
            </div>
          </div>
          <div
            style={{
              border: "1px solid #CACDD1",
              borderRadius: 5,
              marginTop: 5,
            }}
          >
            <div
              className="flex-row"
              style={{ width: "100%", margin: "0em 0.25em" }}
            >
              <div style={{ width: "100%" }}>
                <TextField
                  style={{ margin: 10, width: "90%" }}
                  id="observacion"
                  label="Observación"
                  type="text"
                  disabled={
                    this.state.disabled &&
                    this.state.observationFieldEdit === false
                  }
                  value={this.state.observacion}
                  onChange={(e) => {
                    this.handlerObservationAdd(e.target.value);
                  }}
                />
              </div>
              {this.state.disabled ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-around",
                    alignItems: "center",
                    margin: "0em 0.5em",
                  }}
                >
                  {this.state.observationFieldEdit === false ? (
                    <Tooltip title="Editar observacion">
                      <IconButton
                        aria-label="upload picture"
                        component="span"
                        className="icon-button-agenda-modal"
                        onClick={() => {
                          this.setState({ observationFieldEdit: true });
                        }}
                      >
                        <EditOutlinedIcon fontSize="medium" />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <>
                      <Tooltip title="Actualizar " style={{ margin: "0.25em" }}>
                        <IconButton
                          aria-label="upload picture"
                          component="span"
                          className="icon-button-agenda-modal"
                          onClick={() => {
                            this.updateObservation(
                              !!this.props.dataPatient.id_cita
                                ? this.props.dataPatient.id_cita
                                : this.props.dataPatient.dataPatient.id_cita
                            );
                          }}
                        >
                          <SaveIcon fontSize="medium" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip
                        title="Cancelar Edición"
                        style={{ margin: "0.25em" }}
                      >
                        <IconButton
                          aria-label="upload picture"
                          component="span"
                          className="icon-button-agenda-modal"
                          onClick={() => {
                            this.setState({ observationFieldEdit: false });
                          }}
                        >
                          <BlockIcon fontSize="medium" />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </div>
              ) : null}
            </div>
          </div>

          <div
            style={{
              border: "1px solid #CACDD1",
              borderRadius: 5,
              marginTop: 5,
            }}
          >
            <div style={{ marginLeft: 10, marginTop: 10 }}>
              <br />
              {this.state.signaturePatient != null ? (
                <img
                  style={{ width: 220, height: 75 }}
                  src={this.state.signaturePatient}
                />
              ) : null}
              <br />
              <br />
              <Button
                className="btn btn-sm"
                color="primary"
                onClick={() => {
                  this.setState({ modalSignaturePad: true });
                }}
                style={{ margin: 10, marginTop: 10 }}
              >
                Firma del Paciente
              </Button>
            </div>
          </div>

          {this.props.dataPatient != null ? (
            <>
              {this.props.dataPatient.dataPatient != undefined &&
              this.props.dataPatient.dataPatient != null ? (
                <div>
                  {this.props.dataPatient.dataPatient.hasOwnProperty(
                    "id_admision"
                  ) ? (
                    <div
                      style={{
                        border: "1px solid #CACDD1",
                        borderRadius: 5,
                        marginTop: 5,
                      }}
                    >
                      <div style={{ marginLeft: 10, marginTop: 10 }}>
                        <ReceiptsAdmisions
                          admision={this.props.dataPatient.dataPatient}
                          estadoFacturacion={this.state.estado_facturacion}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </>
          ) : null}

          <div>
            {this.props.dataPatient.dataPatient === null ? (
              <Button
                color="primary"
                onClick={() => {
                  this.createAdmisionProcess(2);
                }}
                style={{ margin: 10, marginTop: 10 }}
                disabled={this.state.disabled}
              >
                Crear
              </Button>
            ) : !this.props.dataPatient.hasOwnProperty("id_admision") ? (
              <Button
                color="primary"
                onClick={() => {
                  this.createAdmisionProcess(1);
                }}
                style={{ margin: 10, marginTop: 10 }}
                disabled={this.state.disabled}
              >
                Guardar
              </Button>
            ) : null}
          </div>

          <ModalMessage
            color={this.state.modalAlert.color}
            title={this.state.modalAlert.title}
            message={this.state.modalAlert.message}
            modal={this.state.openAlert}
            toggle={() => {
              this.onToggleModal();
            }}
            onOk={() => {
              this.onOkModal();
            }}
          />

          <ModalMessage
            color="warning"
            title="Advertencia"
            message="Por favor verifique la fecha de nacimiento"
            modal={this.state.openAlertNoti}
            toggle={() => this.setState({ openAlertNoti: false })}
            onOk={() => {
              this.updatePatient();
            }}
          />

          <ModalMessage
            color="warning"
            title="Advertencia"
            message="¿Está seguro que desea eliminar la discapacidad del paciente?"
            modal={this.state.openAlertDisability}
            toggle={() => this.setState({ openAlertDisability: false })}
            onOk={() => {
              this.updateDisability();
            }}
          />

          {this.state.load ? (
            <Modal
              open={this.state.load}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              style={{ zIndex: 1000 }}
            >
              <div
                style={{
                  position: "absolute",
                  backgroundColor: "#ffffff",
                  width: 200,
                  height: 200,
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                  display: "flex",
                }}
              >
                <div className="load__icon-wrap">
                  <svg className="load__icon">
                    <path
                      fill="#4ce1b6"
                      d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                    />
                  </svg>
                </div>
              </div>
            </Modal>
          ) : null}

          <SearchModalCIE10
            openModalCIE10={this.state.openModalDiagnostico}
            closeModalCIE10={() => {
              this.setState({ openModalDiagnostico: false });
            }}
            Callback={(diagnostic) => {
              this.setState({
                diagnosticAislamiento: diagnostic,
                openModalDiagnostico: false,
              });
            }}
          />

          <ModalAdditionalAppointment
            openModalAdditionalAppointment={
              this.state.openModalAdditionalAppointment
            }
            closeModal={() => {
              this.setState({ openModalAdditionalAppointment: false });
            }}
            activitiesPriceList={this.state.activities}
            activitiesAppointment={this.state.activitiesAppointment}
            date={this.state.date}
            handlerConfirmedAdditionalAppointments={
              this.handlerConfirmedAdditionalAppointments
            }
            confirmedAdditionalAppointments={
              this.state.confirmedAdditionalAppointments
            }
            serter={this.state.serter.filter((ser) => ser.tipo != 2)}
            completeHandlerConfirmedAddionalAppointments={
              this.completeHandlerConfirmedAddionalAppointments
            }
            actualAppointmentClient={this.state.costumer_data}
            actualAppointmentPlan={this.state.plan}
            actualAppointmentPlanDetails={this.state.plans.find(
              (pl) => pl.id_plan == this.state.plan
            )}
            nameInitialPhase={this.state.nameInitialPhase}
            changeNameInitialPhase={this.changeNameInitialPhase}
          />

          <DigitalSignature
            confirmSign={(value) => {
              this.setState(
                {
                  signaturePatient: value,
                },
                () => {
                  console.log("signaturePatient", this.state.signaturePatient);
                }
              );
            }}
            openModalSignature={this.state.modalSignaturePad}
            closeModalSignature={() => {
              this.setState({
                modalSignaturePad: false,
              });
            }}
          />
        </CardBody>
      </Col>
    );
  }
}

export default withStyles(styles, { withTheme: true })(FormAddAdmission);
